import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Divider,
  Box,
  Container,
} from "@mui/material";

function JewellersBlockPolicy() {
  return (
    <>
      <Container
        maxWidth="xl"
        className="privacy-container jewellers_block_policy"
        sx={{mt: 1}}
      >
        <Typography variant="h4" className="privacy-title" gutterBottom>
          Jewellers Block Policy
        </Typography>

        <Box className="privacy-content jewellers_block_policy">
          <Typography variant="body1" paragraph>
            <h3 style={{marginBottom: "10px"}}>Policy Wording</h3>
            Wherever reference herein is made to ‘Company’ or ‘Underwriter(s)’
            it shall be deemed to mean the ‘Insurer(s)’. Wherever reference
            herein is made to the ‘Policy’ it shall be deemed to mean the
            ‘Contract’.
          </Typography>

          <Typography variant="body1" paragraph>
            Nothing in this Contract shall be construed to be:
            <br />
            (a) A condition precedent to coverage; or
            <br />
            (b) A warranted statement by the (re)insured, unless expressly
            stated to be one in this contract.
          </Typography>

          <Typography variant="body1" paragraph>
            Communicable Disease Endorsement JS2020-011
            <br />
            Cyber and Data Exclusion with Limited Write-Back for Targeted Theft
            JS2020-014
            <br />
            Financial Default Exclusion Clause
            <br />
            Insolvency Exclusion Clause
            <br />
            Institute Radioactive Contamination Chemical Biological Bio-Chemical
            and Electromagnetic Weapons Exclusion Clause – CL370
            <br />
            Invalid Payments Exclusion Clause
            <br />
            Sanctions Suspension Clause LMA3200
            <br />
            Terrorism Exclusion Endorsement (NMA2920) in respect of static risks
            <br />
            Termination of transit clause (Terrorism) - Whilst in the Ordinary
            Course of Transit – JC2009/056
            <br />
            US Terrorism Risk Insurance Act of 2002 as amended (Purchased)
            Clause LMA5389
            <br />
            US Terrorism Risk Insurance Act of 2002 as amended (Not Purchased)
            Clause LMA 5390
            <br />
            Territorial Exclusion Clause LMA5584B with Excluded Territories RUB,
            Iran, Iraq, North Korean, Somalia, Sudan, Cuba
          </Typography>

          <Typography variant="body1" paragraph>
            All claims on this policy are payable to Amwins Global Risks Limited
            and it is agreed that such payment, whether in account or otherwise
            shall be a complete discharge to Underwriters concerned.
            Individually signed payment authorities are accordingly not
            required.
          </Typography>

          <Typography variant="body1" paragraph>
            <strong>Express Warranties:</strong> None, other than as may exist
            in this document or in the wording that forms part of this Contract.
            Nothing in this Contract shall be construed as a warranty unless it
            is expressly stated as such.
          </Typography>

          <Typography variant="body1" paragraph>
            <strong>Subjectivities:</strong> This contract is subject to a
            satisfactory security survey being carried out within 30 days of
            inception at the Named Risk location(s) by surveyors previously
            agreed by underwriters and all recommendations (if any) being
            complied with within timeframes specified by insurers.
            <br />
            Failure to comply within timeframes may result in coverage being
            prejudiced, terms amended or coverage being void.
          </Typography>

          <Typography variant="body1" paragraph>
            <strong>Choice of Law and Jurisdiction:</strong> Any dispute between
            the Insured and Insurers relating to this contract or to a claim
            hereon shall be governed by the law and practice of the State of New
            York and the provisions of the contract shall be interpreted and
            construed in accordance with such law and practice.
          </Typography>

          <Typography variant="body1" paragraph>
            Any and all claims or disputes and any non-contractual obligations
            arising out of or in connection with this contract shall be subject
            to the exclusive jurisdiction of the courts of the State of New
            York.
          </Typography>

          <Typography variant="body1" paragraph>
            <br /> <strong>Service of Suit Clause (U.S.A.) LMA5020B</strong>,
            <br /> Any provision in any form specified in the Conditions which
            provides for any law and/or practice other than that stated in this
            Choice of Law and Jurisdiction is deemed deleted.
            <br /> This General Condition shall supersede the ‘Law and Practice’
            provision contained in each of the Institute Clauses referred to
            elsewhere herein.
          </Typography>

          <Typography variant="body1" paragraph>
            <strong>Premium Payment Terms:</strong> LSW 3001 Premium Payment
            Clause.
            <br /> Payable in four equal quarterly instalments with the second
            and subsequent instalments being payable as additional premiums.
            <br /> 10% No Claims Bonus (Net Absolute) as more fully described in
            the attached wording, payable at expiry.
            <br /> In respect of TRIA (if applicable) per annum.
          </Typography>

          <Typography variant="body1" paragraph>
            <strong>
              Taxes payable by Insured and Administered By insurers:
            </strong>
            None applicable as at Inception Date. Subject to automatic amendment
            during the period of insurance, without Insurers' prior approval,
            effective from the date of any legislative change affecting the
            taxation applicable to this contract.
          </Typography>

          <Typography variant="body1" paragraph>
            <strong>
              Taxes payable by Insurers and Administered by insured or their
              agent:
            </strong>{" "}
            Non-Applicable
          </Typography>

          <Typography variant="body1" paragraph>
            <strong>Recording, Transmitting And Storing Information:</strong>
            <br />
            <strong>Insurer Contract Documentation:</strong> This document and
            all attachments including a wording (where applicable), detail the
            contract terms entered into by the Insurers and constitutes the
            contract document.
            <br />
            For contract changes, the Contract Endorsement(s) agreed by Insurers
            shall form the evidence of the changes agreed. These changes will
            also apply to the wording that forms part of this contract.
            <br />
            Where the attached wording(s) or clauses refer to a policy schedule
            or declarations, it is deemed to mean ‘Risk Details’ and
            ‘Information’.
            <br />
            Where this contract refers to this policy, slip, placement or
            document, these terms shall be understood to mean this ‘Contract’.
            <br />
            Wherever the following words appear in this contract, the same shall
            be deemed to be synonymous.
          </Typography>

          <Typography variant="body1" paragraph>
            Insureds are advised that if any terms, clauses or conditions are
            unclear they should contact{" "}
            <strong>Surya Insurance Services LLC</strong> immediately.
            <br />
            Surya Insurance Services LLC and/or their agents are authorised to
            issue any and all Certificates of Insurance as may be required in
            evidence of the insurance hereby provided.
            <br />
            Unless otherwise specified below no further Insurer contract
            documentation will be issued.
          </Typography>

          <Typography variant="body1" paragraph>
            <strong>Notices:</strong> This contract is subject to US state
            surplus lines requirements. It is the responsibility of the surplus
            lines broker to affix a surplus lines notice to the contract
            document before it is provided to the Insured.
            <br />
            In the event that the surplus lines notice is not affixed to the
            contract document the Insured should contact the surplus lines
            broker.
            <br />
            Any further documentation changing this contract, agreed in
            accordance with the contract change provisions set out in this
            contract, shall form the Evidence of such change.
          </Typography>
        </Box>

        <Card
          className="policy-card"
          style={{boxShadow: "none", padding: "0px"}}
        >
          <CardContent style={{padding: "0px 10px"}}>
            <Typography variant="h5" className="card-title" gutterBottom>
              INSURANCE CONTRACT WORDING
            </Typography>

            <Typography className="card-body" paragraph>
              <strong>WE THE UNDERWRITERS</strong> will indemnify the Insured in
              respect of all risks of Physical Loss or Damage to the property
              hereinafter mentioned during the period from xx to xx both days at
              00.01am Local Standard Time at the Address of the Insured, herein
              as follows:
            </Typography>

            <Divider sx={{my: 2}} />

            <Typography variant="subtitle1" className="card-subtitle">
              1. SCHEDULE OF PROPERTY AND AMOUNTS INSURED
              <p style={{color: "#555", fontWeight: "400"}}>
                The schedule of property and amounts insured is as follows,
                subject to the limitations and conditions hereinafter
                contained:{" "}
              </p>
            </Typography>

            <ul className="card-list" style={{listStyle: "upper-alpha"}}>
              <li>
                On Stock as per inventory described in books and records
                (including other people’s goods) —{" "}
                <strong>USD 5,000,000</strong>
              </li>
              <li>
                On Money in locked safe at Insured’s premises per endorsement(s)
                — <strong>Money – off premises NIL</strong>
                <br />
                <span style={{marginTop: "7px", display: "block"}}>
                  {" "}
                  Money – off premises — <strong> NIL</strong>{" "}
                </span>
              </li>

              <li>
                On Patterns, Moulds, Models and Dies at Insured’s premises, per
                endorsement(s) — <strong>NIL</strong>
              </li>
              <li>
                On Furniture, Fixtures, Machinery, Tools and Fittings at
                Insured’s premises, per endorsement(s) — <strong>NIL</strong>
              </li>
              <li>
                On Insured’s interest as tenant under lease or other rental
                agreement in Improvement and Betterments to premises, per
                endorsement(s) — <strong>NIL</strong>
              </li>
            </ul>

            <Divider sx={{my: 2}} />

            <Typography variant="subtitle1" className="card-subtitle">
              2. LIMITATIONS OF LIABILITY
              <p style={{color: "#555", fontWeight: "400"}}>
                In respect of property insured under item 1.A, the maximum
                liability of the Underwriters resulting from any one loss,
                disaster or casualty is limited to:{" "}
              </p>
            </Typography>

            <ul className="card-list" style={{listStyle: "upper-alpha"}}>
              <li>
                In respect of property of the Insured premises described herein:
                — <strong>USD 5,000,000</strong>
              </li>
              <li style={{paddingLeft: "20px"}}>
                <ul style={{listStyle: "num", paddingLeft: "5px"}}>
                  <li>
                    In respect of property which is in transit by first class
                    registered mail, or railway express (subject to the
                    stipulations of Exclusion E Section 5), —{" "}
                    <strong>USD 50,000</strong>
                    <br />
                    <span style={{marginTop: "7px", display: "block"}}>
                      {" "}
                      Or by armoured car service: —{" "}
                      <strong> USD750,000</strong>{" "}
                    </span>
                  </li>
                  <li>
                    In respect of property which is deposited in the safe or
                    vault of a bank or safe deposit company —{" "}
                    <strong>USD5,000,000</strong>
                  </li>
                  <li>
                    In respect of property which is the custody of a dealer in
                    property of the kind insured hereunder not employed by or
                    associated with the Insured, but property deposited for safe
                    keeping with such a dealer by the Insured or his or their
                    authorized representatives while travelling is subject to
                    the limit expressed in Clause E of this Section; —{" "}
                    <strong>USD 100,000</strong>
                  </li>
                </ul>
              </li>

              <li>
                In respect of shipments by first class registered air mail or
                air express (subject to the stipulations of Exclusion E of
                Section 5) sent to any one addressee at any one address during
                any one day — <strong>USD 50,000</strong>
              </li>
              <li>
                In respect of shipments in transit by Federal Express Secure
                overnight or similar — <strong>USD 75,000</strong>
              </li>
              <li>
                In respect of property elsewhere and not included in Clauses A,
                B, C and D of this section or otherwise limited herein —{" "}
                <strong>USD 500,000</strong>
              </li>
            </ul>

            <Divider sx={{my: 2}} />
            <Typography variant="h6" sx={{fontWeight: 600, mb: 1}}>
              3. PROPERTY INSURED
            </Typography>

            <Typography variant="body1" paragraph>
              The property insured is as follows:
            </Typography>

            <Box sx={{pl: 2, lineHeight: 1.8}}>
              <ul style={{listStyle: "upper-alpha", paddingRight: "5px"}}>
                <li style={{paddingLeft: "5px", marginBottom: "10px"}}>
                  Pearls, precious and semi-precious stones, jewels, jewellery,
                  watches and watch movements, gold, silver, platinum, other
                  precious metals and alloys and other stock usual to the
                  conduct of the Insured’s business, owned by the Insured.
                </li>
                <li style={{paddingLeft: "5px", marginBottom: "10px"}}>
                  Property as described above, delivered or entrusted to the
                  Insured by other who are not dealers in such property or
                  otherwise engaged in the jewellery trade;
                </li>
                <li style={{paddingLeft: "5px", marginBottom: "10px"}}>
                  Property as above described, delivered or entrusted to the
                  Insured by others who are dealers in such property or
                  otherwise engaged in the jewellery trade, but only to the
                  extent of the Insured’s own actual interest therein because of
                  money actually advanced thereon, or legal liability for loss
                  of or damage thereto.
                </li>
                <li style={{paddingLeft: "5px", marginBottom: "10px"}}>
                  Grading certificates, bank notes or cheques whether the same
                  be the property of the Assured or entrusted to him or them on
                  sale or return or on approbation or for work to be done
                  thereon or for safe custody or for any other purpose
                  whatsoever.
                </li>
              </ul>
            </Box>

            <Divider sx={{my: 4}} />

            {/* 4. TERRITORIAL LIMITS */}
            <Typography variant="h6" sx={{fontWeight: 600, mb: 1}}>
              4. TERRITORIAL LIMITS
            </Typography>

            <Typography variant="body1" paragraph>
              The property described above is covered while in principal
              locations within the United States of America or in transit
              worldwide but subject always to the Territorial Exclusion and any
              other limitations, conditions, exclusions and exceptions stated
              herein.
            </Typography>

            <Divider sx={{my: 4}} />

            {/* 5. EXCLUSIONS */}
            <Typography variant="h6" sx={{fontWeight: 600, mb: 1}}>
              5. EXCLUSIONS
            </Typography>

            <Typography variant="body1" paragraph>
              This Contract insures against all risks of physical loss of or
              damage to the above described property arising from any cause
              whatsoever
            </Typography>

            <span style={{marginBottom: "10px", display: "block"}}>
              {" "}
              EXCEPT:
            </span>
            <Box sx={{pl: 2, lineHeight: 1.8}}>
              <ul style={{listStyle: "upper-alpha", paddingRight: "5px"}}>
                <li style={{marginBottom: "10px", paddingLeft: "5px"}}>
                  Loss, damage or expense caused by or resulting from sabotage,
                  theft, conversion or other act or omission of a dishonest
                  character (1) on the part of the Insured or his or their
                  employees, or (2) on the part of any person to whom the
                  property hereby insured may be delivered or entrusted by
                  whomsoever for any purpose whatsoever, unless such loss,
                  damage or expense arising while the goods are deposited for
                  safe custody by the Insured, officer of the corporation,
                  member of the firm or salesman while travelling, or while the
                  goods are in the custody of (a) the Post Office Department as
                  first class registered mail, or (b) a carrier as mentioned in
                  Section 2, or (c) a person servicing as a mere porter or
                  helper not on the payroll of the Insured.
                </li>
                <li style={{marginBottom: "10px", paddingLeft: "5px"}}>
                  Loss or damage caused by:
                  <Box sx={{pl: 2}}>
                    <Typography>i. delay, loss of market;</Typography>
                    <Typography>ii. gradual deterioration;</Typography>
                    <Typography>
                      iii. moth, insect, vermin, rot, fungus, mold, infestation
                      or any similar pests, organisms or microorganisms;
                    </Typography>
                    <Typography>
                      iv. inherent vice, corrosion, rust, dampness of
                      atmosphere, freezing or extremes of temperature;
                    </Typography>
                    <Typography>
                      v. insufficient or defective packing; or
                    </Typography>
                    <Typography>
                      vi. sustained while the property is being actually worked
                      upon, including being repaired, restored, retouched and
                      directly resulting therefrom.
                    </Typography>
                  </Box>
                </li>
                <li style={{marginBottom: "10px", paddingLeft: "5px"}}>
                  Loss or damage directly or indirectly occasioned by, happening
                  through or in consequence of war, invasion, acts of foreign
                  enemies, hostilities (whether war be declared or not), civil
                  war, rebellion, revolution, insurrection, military or usurped
                  power or confiscation or nationalisation or requisition or
                  destruction of or damage to property by or under the order of
                  any government or public or local authority.
                </li>

                <li style={{marginBottom: "10px", paddingLeft: "5px"}}>
                  Loss or damage occurring at the Insured's premises caused by
                  or resulting from:
                  <Box sx={{pl: 2}}>
                    <Typography>1. Earthquake</Typography>
                    <Typography>
                      2. flood, surface water, waves, tidal water or tidal wave,
                      overflow of streams or other bodies of water or spray from
                      any of the foregoing all whether driven by wind or
                      not.{" "}
                    </Typography>
                  </Box>
                  <p style={{marginTop: "10px"}}>
                    {" "}
                    However, if the peril of fire is not excluded hereunder this
                    Policy will cover fire damage occurring during or resulting
                    from perils enumerated in 1 and 2 above.
                  </p>
                </li>

                <li style={{marginBottom: "0px", paddingLeft: "5px"}}>
                  Loss or damage occurring in the course of transit to shipments
                  by:
                  <Box sx={{pl: 2}}>
                    <Typography sx={{pb: 1}}>
                      a. mail unless registered first class;
                    </Typography>
                    <Typography sx={{pb: 1}}>
                      b. railroad, waterborne or air carriers unless under
                      receipt of their passenger parcel transportation or
                      baggage services;{" "}
                    </Typography>
                    <Typography sx={{pb: 1}}>
                      c. motor carriers or truckmen other than under receipt of;
                      <br />
                      <Typography sx={{pl: 2}}>
                        i. Those operating exclusively as a customer parcel
                        delivery service;
                      </Typography>
                      <Typography sx={{pl: 2}}>
                        ii. Armoured car service;{" "}
                      </Typography>
                      <Typography sx={{pl: 2}}>
                        iii. The parcel transportation or baggage services of
                        passenger bus lines.{" "}
                      </Typography>
                    </Typography>
                  </Box>
                </li>

                <li style={{marginBottom: "10px", paddingLeft: "5px"}}>
                  Breakage of articles of a fragile or brittle nature, unless
                  caused by fire, lightning, explosion, aircraft, vehicles,
                  flood, earthquake, windstorm, strikers, rioters, persons
                  taking part in labour disturbances or civil commotions,
                  burglars, thieves or accident to the conveyance in which the
                  property insured is being carried (but only when and to the
                  same extent that such perils are otherwise covered under this
                  Contract). It is understood & agreed that this exclusion does
                  not apply to mounting and remounting of stones and in respect
                  of pearls being strung and restrung.
                </li>

                <li style={{marginBottom: "10px", paddingLeft: "5px"}}>
                  Loss of or damage to goods sold on an instalment plan from the
                  time they leave the Insured's custody.
                </li>

                <li style={{marginBottom: "10px", paddingLeft: "5px"}}>
                  Loss or damage while the property is being worn (except
                  watches worn solely for the purposes of adjustment, such cover
                  being subject to the Limit of Liability and territorial
                  limits) by the Insured, officer of the corporation, member of
                  the firm, director, agent, employee, servant or messenger of
                  the Insured, or by any dealer or other person, firm or
                  corporation engaged in the jewellery trade or by any of their
                  officers, directors, agents, employees, servants or messengers
                  or by any member of the family, relative or friend of any of
                  the aforesaid, or while in their custody for such purpose.
                </li>

                <li style={{marginBottom: "10px", paddingLeft: "5px"}}>
                  Loss of or damage to property insured hereunder while in or
                  upon any automobile, motorcycle or any other vehicle unless,
                  at the time the loss or damage occurs, there is actually in or
                  upon such vehicle, the Insured, or a permanent employee of the
                  Insured, or a person whose sole duty it is to attend the
                  vehicle. This exclusion shall not apply to property in the
                  custody of a carrier mentioned in Section 2 hereof, or in the
                  custody of the Post Office Department as first class
                  registered mail.
                </li>

                <li style={{marginBottom: "10px", paddingLeft: "5px"}}>
                  Loss of or damage to the property hereby insured while at any
                  exhibition promoted or financially assisted by any public
                  authority or by any trade association.
                </li>

                <li style={{marginBottom: "10px", paddingLeft: "5px"}}>
                  Loss of or damage to property contained in show windows at the
                  Insured's premises by theft or attempted theft accomplished by
                  or resulting from the smashing or cutting of such windows
                  except as may be endorsed hereon.
                </li>

                <li style={{marginBottom: "10px", paddingLeft: "5px"}}>
                  Loss of or damage to property exhibited by the Insured in show
                  cases or show windows elsewhere than at the premises of the
                  Insured as referred to in this Policy except as may be
                  endorsed hereon.
                </li>

                <li style={{marginBottom: "10px", paddingLeft: "5px"}}>
                  Any Stock missing at stocktaking in respect of which no claim
                  has been previously notified unless the loss be proved by the
                  Insured to be due to a peril covered by the Policy. Or any
                  shortage in Stock claimed to have been forwarded in a package
                  when the package is received by the consignee in apparent good
                  order with seals unbroken; Or loss of or damage to Stock when
                  sent "cash on delivery" with the privilege of inspection by
                  the consignee before delivery.
                </li>

                <li style={{marginBottom: "10px", paddingLeft: "5px"}}>
                  Radioactive Contamination, Chemical; Biological, Bio-Chemical
                  and Electromagnetic Weapons Exclusion:
                  <br />
                  This clause shall be paramount and shall override anything
                  contained in this insurance inconsistent therewith. In no case
                  shall this insurance cover loss, damage, liability or expense
                  directly or indirectly caused by or contributed to by or
                  arising from:
                  <ul
                    style={{
                      marginTop: "10px",
                      listStyle: "none",
                      paddingLeft: "10px",
                    }}
                  >
                    <li style={{marginBottom: "10px", paddingLeft: "5px"}}>
                      1. Ionising radiations from or contamination by
                      radioactivity from any nuclear fuel, or from any nuclear
                      waste or from the combustion of nuclear fuel.
                    </li>
                    <li style={{marginBottom: "10px", paddingLeft: "5px"}}>
                      2. The radioactive, toxic, explosive or other hazardous or
                      contaminating properties of any nuclear installation,
                      reactor or other nuclear assembly or nuclear component
                      thereof.
                    </li>
                    <li style={{marginBottom: "10px", paddingLeft: "5px"}}>
                      3. Any weapon or device employing atomic or nuclear
                      fission and/or fusion or other like reaction or
                      radioactive force or matter.
                    </li>
                    <li style={{marginBottom: "10px", paddingLeft: "5px"}}>
                      4. The radioactive, toxic, explosive or other hazardous or
                      contaminating properties of any radioactive matter. The
                      exclusion in this sub-clause does not extend to
                      radioactive isotopes, other than nuclear fuel, when such
                      isotopes are being prepared, carried, stored, or used for
                      commercial, agricultural, medical, scientific or other
                      similar peaceful purposes.
                    </li>
                    <li style={{marginBottom: "10px", paddingLeft: "5px"}}>
                      5. Any chemical, biological, bio-chemical, or
                      electromagnetic weapon.
                    </li>
                  </ul>
                </li>

                <li style={{marginBottom: "10px", paddingLeft: "5px"}}>
                  <strong>
                    {" "}
                    Terrorism Exclusion (in respect to static risks):{" "}
                  </strong>
                  <br />
                  Notwithstanding any provision to the contrary within this
                  insurance or any endorsement thereto it is agreed that this
                  insurance excludes loss, damage, cost or expense of whatsoever
                  nature directly or indirectly caused by, resulting from or in
                  connection with any act of terrorism regardless of any other
                  cause or event contributing concurrently or in any other
                  sequence to the loss.
                  <br />
                  For the purpose of this clause, an act of terrorism means an
                  act, including but not limited to the use of force or violence
                  and/or the threat thereof, of any person or group(s) of
                  persons, whether acting alone or on behalf of or in connection
                  with any organisation(s) or government(s), committed for
                  political, religious, ideological or similar purposes
                  including the intention to influence any government and/or to
                  put the public, or any section of the public, in fear.
                  <br />
                  This insurance also excludes loss, damage, cost or expense of
                  whatsoever nature directly or indirectly caused by, resulting
                  from or in connection with any action taken in controlling,
                  preventing, suppressing or in any way relating to any act of
                  terrorism.
                  <br />
                  If the Underwriters allege that by reason of this exclusion,
                  any loss, damage, cost or expense is not covered by this
                  insurance, the burden of proving the contrary shall be upon
                  the Insured.
                  <br />
                  In the event any portion of this clause is found to be invalid
                  or unenforceable, the remainder shall remain in full force and
                  effect.
                </li>

                <li style={{marginBottom: "10px", paddingLeft: "5px"}}>
                  <strong> Communicable Disease: </strong>
                  <ul
                    style={{
                      marginTop: "10px",
                      listStyle: "none",
                      paddingLeft: "10px",
                    }}
                  >
                    <li style={{marginBottom: "10px", paddingLeft: "5px"}}>
                      1. Notwithstanding any provision to the contrary within
                      this insurance, this insurance does not insure any loss,
                      damage, liability, claim, cost or expense of whatsoever
                      nature caused by, contributed to by, resulting from,
                      arising out of, or in connection with a Communicable
                      Disease or the fear or threat (whether actual or
                      perceived) of a Communicable Disease.
                    </li>
                    <li style={{marginBottom: "10px", paddingLeft: "5px"}}>
                      For the purposes of this clause, loss, damage, liability,
                      claim, cost, expense or other sum, includes, but is not
                      limited to, any cost to clean-up, detoxify, remove,
                      monitor or test.
                    </li>

                    <li style={{marginBottom: "10px", paddingLeft: "5px"}}>
                      1.1. For a Communicable Disease, or
                    </li>
                    <li style={{marginBottom: "10px", paddingLeft: "5px"}}>
                      1.2. Any property insured hereunder that is affected by
                      such Communicable Disease.
                    </li>
                    <li style={{marginBottom: "10px", paddingLeft: "5px"}}>
                      2. As used herein, a Communicable Disease means any
                      disease which can be transmitted by means of any substance
                      or agent from any organism to another organism where:
                      <ul style={{listStyle: "none"}}>
                        <li style={{marginBottom: "10px", paddingLeft: "5px"}}>
                          2.1. The substance or agent includes, but is not
                          limited to, a virus, bacterium, parasite or other
                          organism or any variation thereof, whether deemed
                          living or not.
                        </li>
                        <li style={{marginBottom: "10px", paddingLeft: "5px"}}>
                          2.2. The method of transmission, whether direct or
                          indirect, includes, but is not limited to, airborne
                          transmission, bodily fluid transmission, transmission
                          from or to any surface or object, solid, liquid or gas
                          or between organisms.
                        </li>
                      </ul>
                    </li>

                    <li style={{marginBottom: "10px", paddingLeft: "5px"}}>
                      3. This endorsement applies to all coverage extensions,
                      additional coverages, exceptions to any exclusion and
                      other coverage grant(s).
                    </li>

                    <li style={{marginBottom: "0px", paddingLeft: "5px"}}>
                      JS2020-011
                    </li>
                    <li style={{marginBottom: "10px", paddingLeft: "5px"}}>
                      23 June 2020
                    </li>
                  </ul>
                </li>

                <li style={{marginBottom: "10px", paddingLeft: "5px"}}>
                  <strong> Financial Default: </strong>
                  <br />
                  This insurance excludes losses directly or indirectly arising
                  from financial default or non-payment or when a company can no
                  longer or chooses to no longer meet its debt obligations in
                  relation to property hereby insured.
                  <p>
                    {" "}
                    For the purposes of this exclusion, the terms "debt” and
                    "financial default” shall only refer to outstanding amounts
                    for which a sales invoice has been issued and settlement not
                    been received and does not include failure of a third party
                    to return or pay for insured property delivered to such
                    third party on approval, on consignment, or as a bailment.
                  </p>
                </li>

                <li style={{marginBottom: "10px", paddingLeft: "5px"}}>
                  <strong> Insolvency: </strong>
                  <br />
                  This insurance excludes losses directly or indirectly arising
                  from the insolvency, administration, voluntary arrangements
                  with creditors, bankruptcy or receivership of the insured or
                  any third party to whom the property insured has been sold by
                  the Insured but does not include any of the foregoing in
                  respect of a third party to whom insured property has been
                  delivered on approval, on consignment or as a bailment.
                  <br />
                  This clause also excludes loss, damage, cost or expense of
                  whatsoever nature directly or indirectly caused by, resulting
                  from or in connection with any action taken in controlling,
                  preventing, suppressing or in any way relating to any act of
                  terrorism.
                  <br />
                  If the Underwriters allege that by reason of this exclusion,
                  any loss, damage, cost or expense is not covered by this
                  insurance, the burden of proving the contrary shall be upon
                  the Insured.
                  <br />
                  In the event any portion of this clause is found to be invalid
                  or unenforceable, the remainder shall remain in full force and
                  effect.
                </li>

                <li style={{marginBottom: "10px", paddingLeft: "5px"}}>
                  <strong> Invalid Payments Exclusion: </strong>
                  <br />
                  This insurance excludes any claim in respect of the insured
                  interest hereunder where the loss has been sustained by the
                  Insured consequent upon the Insured handling over such insured
                  interest to any third party – following a sales transaction,
                  against payment by:
                  <ul style={{listStyle: "none", marginTop: "10px"}}>
                    <li style={{marginBottom: "10px", paddingLeft: "5px"}}>
                      1. Cheque, banker's draft, or any other form of money
                      order, where such cheque, banker's draft or other form of
                      money order, shall prove to be false, fraudulent or
                      otherwise invalid or uncollectable for any reason
                      whatsoever.
                    </li>
                    <li style={{marginBottom: "10px", paddingLeft: "5px"}}>
                      2. Cash, currency or bank notes which prove to be
                      counterfeit, false or otherwise invalid for any reason
                      whatsoever.
                    </li>

                    <li style={{marginBottom: "10px", paddingLeft: "5px"}}>
                      3. Credit card, where the use of the same has been false,
                      fraudulent or invalid, or when payment of the amount due
                      is uncollectable for any reason whatsoever.
                    </li>
                  </ul>
                </li>

                <li style={{marginBottom: "10px", paddingLeft: "5px"}}>
                  <strong> Territorial Exclusion: </strong>
                  <br />
                  Notwithstanding anything to the contrary in this Policy, this
                  Policy excludes any loss, damage, liability, cost or expense
                  of whatsoever nature, directly or indirectly arising from or
                  in respect of any:
                  <ul style={{listStyle: "none", marginTop: "10px"}}>
                    <li style={{marginBottom: "10px", paddingLeft: "5px"}}>
                      i. Entity domiciled, resident, located, incorporated,
                      registered or established in an Excluded Territory;
                    </li>
                    <li style={{marginBottom: "10px", paddingLeft: "5px"}}>
                      ii. Property or asset located in an Excluded Territory;
                    </li>
                    <li style={{marginBottom: "10px", paddingLeft: "5px"}}>
                      iii. Individual that is physically in an Excluded
                      Territory;
                    </li>
                    <li style={{marginBottom: "10px", paddingLeft: "5px"}}>
                      iv. Claim, action, suit or enforcement proceeding brought
                      or maintained in an Excluded Territory;
                    </li>
                    <li style={{marginBottom: "10px", paddingLeft: "5px"}}>
                      v. Payment in an Excluded Territory.
                    </li>
                  </ul>
                  This exclusion will not apply to any coverage or benefit
                  required to be provided by the insurer by law or regulation
                  applicable to that insurer, however, the terms of any
                  sanctions clause will prevail.
                  <br />
                  <p style={{marginTop: "5px"}}>
                    {" "}
                    For purposes of this exclusion, “Excluded Territory” means:
                  </p>
                  <ul style={{listStyle: "none", marginTop: "10px"}}>
                    <li style={{marginBottom: "10px", paddingLeft: "5px"}}>
                      ➢ Belarus (Republic of Belarus);
                    </li>
                    <li style={{marginBottom: "10px", paddingLeft: "5px"}}>
                      ➢ Russian Federation;
                    </li>
                    <li style={{marginBottom: "10px", paddingLeft: "5px"}}>
                      ➢ Ukraine (including any disputed regions of Ukraine and
                      including the Crimean Peninsula);
                    </li>
                    <li style={{marginBottom: "10px", paddingLeft: "5px"}}>
                      ➢ Iran;
                    </li>
                    <li style={{marginBottom: "10px", paddingLeft: "5px"}}>
                      ➢ Iraq;
                    </li>
                    <li style={{marginBottom: "10px", paddingLeft: "5px"}}>
                      ➢ North Korea;
                    </li>
                    <li style={{marginBottom: "10px", paddingLeft: "5px"}}>
                      ➢ Somalia;
                    </li>
                    <li style={{marginBottom: "10px", paddingLeft: "5px"}}>
                      ➢ Sudan;
                    </li>
                    <li style={{marginBottom: "10px", paddingLeft: "5px"}}>
                      ➢ Cuba;
                    </li>
                  </ul>
                </li>

                <li style={{marginBottom: "10px", paddingLeft: "5px"}}>
                  <strong>
                    {" "}
                    Cyber and Data Exclusion with Limited Write-back for
                    Targeted Theft:{" "}
                  </strong>
                  <br />
                  The following shall apply to the whole of this insurance
                  contract:
                  <ul style={{listStyle: "none", marginTop: "10px"}}>
                    <li style={{marginBottom: "10px", paddingLeft: "5px"}}>
                      A. We will not pay for any Cyber loss, damage, liability,
                      cost or expense directly or indirectly caused by:
                      <ul
                        style={{
                          listStyle: "none",
                          marginTop: "10px",
                          paddingLeft: "10px",
                        }}
                      >
                        <li style={{marginBottom: "10px", paddingLeft: "5px"}}>
                          1. The use of or inability to use any computer,
                          computer system, computer software programme, or
                          process or any other electronic system;
                        </li>
                        <li style={{marginBottom: "10px", paddingLeft: "5px"}}>
                          2. Any computer virus or malicious code;
                        </li>
                        <li style={{marginBottom: "10px", paddingLeft: "5px"}}>
                          3. Any computer-related hoax relating to 1 and/or 2
                          above.
                        </li>
                      </ul>
                    </li>

                    <li style={{marginBottom: "10px", paddingLeft: "5px"}}>
                      B. However, it is understood and agreed that clause A
                      shall not apply to an otherwise covered physical loss of
                      the subject matter insured directly caused by theft,
                      robbery, burglary, hold-up or other criminal taking if:
                      <ul
                        style={{
                          listStyle: "none",
                          marginTop: "10px",
                          paddingLeft: "10px",
                        }}
                      >
                        <li style={{marginBottom: "10px", paddingLeft: "5px"}}>
                          4. A computer, computer system, computer software
                          programme, malicious code, computer virus or process
                          or any other electronic system is used in the
                          commission of the act(s) of theft, burglary, robbery,
                          hold-up or other criminal taking; and
                        </li>
                        <li style={{marginBottom: "10px", paddingLeft: "5px"}}>
                          5. The act in 4 above is solely targeted at or against
                          the Insured, the Insured’s property or one of the
                          Named Location(s) herein.
                        </li>
                      </ul>
                    </li>
                    <p style={{marginBottom: "10px"}}>
                      {" "}
                      The burden of proving a covered loss under this limited
                      write-back shall be on the Insured.{" "}
                    </p>

                    <li style={{marginBottom: "10px", paddingLeft: "5px"}}>
                      C. We will not pay for any loss of or damage to any
                      electronic data (for example files or images) wherever it
                      is stored.
                    </li>
                    <li style={{marginBottom: "10px", paddingLeft: "5px"}}>
                      JS2020-013 <br /> 29 October 2020
                    </li>
                    <li style={{marginBottom: "10px", paddingLeft: "5px"}}></li>
                    <li style={{marginBottom: "10px", paddingLeft: "5px"}}>
                      <h3>CONDITIONS</h3>
                      <ul style={{listStyle: "num"}}>
                        <li style={{marginBottom: "10px", paddingLeft: "5px"}}>
                          To the extent of 10% of the Limit of Liability stated
                          in Section 2A as applicable at such premises, the
                          Underwriters will pay for damage (except by fire) to
                          that part of the building occupied by the Insured
                          directly resulting from theft or any attempt thereat,
                          provided the Insured is the owner of such premises or
                          is legally liable for such damage; but in no event
                          shall this Section apply to glass or to any lettering
                          or ornamentation thereon. The Underwriters' combined
                          liability under this Section and under Item A of
                          Section 2 shall not exceed the amount of insurance
                          shown under Item A of Section 2 for the premises at
                          which such loss or damage occurs.
                        </li>
                        <li style={{marginBottom: "10px", paddingLeft: "5px"}}>
                          {" "}
                          <strong>
                            {" "}
                            No changes without Underwriters consent:{" "}
                          </strong>
                          <p style={{marginTop: "10px"}}>
                            No assignment of or change of interest under this
                            Policy shall bind the Underwriters, nor shall any
                            change in or additions to the premises of the
                            Insured stated in this Policy be covered hereunder,
                            unless the consent of the Underwriters shall be
                            endorsed hereon.
                          </p>
                          <p style={{marginTop: "10px"}}>
                            No agreement, condition, or declaration of this
                            Policy shall be waived or changed unless the consent
                            of the Underwriters shall be endorsed hereon. No
                            notice to, or knowledge possessed by any agent or
                            any other person shall be held to effect a waiver or
                            change in any part of this Policy unless endorsed
                            hereon.
                          </p>
                        </li>

                        <li>
                          <strong>
                            {" "}
                            Insured’s obligations. It is a condition of this
                            contract that:{" "}
                          </strong>
                          <ul
                            style={{
                              listStyle: "upper-alpha",
                              paddingLeft: "20px",
                            }}
                          >
                            <li
                              style={{marginBottom: "10px", paddingLeft: "5px"}}
                            >
                              The Insured will maintain a detailed and itemized
                              inventory of his or their property and separate
                              listing of all travellers' stocks, in such manner
                              that the exact amount of loss or damage can be
                              accurately determined therefrom by the
                              Underwriters.
                            </li>
                            <li
                              style={{marginBottom: "10px", paddingLeft: "5px"}}
                            >
                              The Insured will maintain during the life of this
                              Policy, insofar as is within his or their control,
                              watchmen and/or the protective devices as
                              described in the written proposal and/or
                              declaration attached hereto and/or in endorsements
                              attached hereto.
                            </li>
                            <li
                              style={{marginBottom: "10px", paddingLeft: "5px"}}
                            >
                              The Insured will ensure that the Insured premises
                              have a centrally monitored intruder alarm that is
                              in good working order and activated whenever such
                              location is left unattended.
                            </li>
                            <li
                              style={{marginBottom: "10px", paddingLeft: "5px"}}
                            >
                              The Insured will ensure that the Insured premises
                              have centrally monitored fire alarm and smoke
                              detectors, which are in good working order and
                              activated at all times.
                            </li>
                            <li
                              style={{marginBottom: "10px", paddingLeft: "5px"}}
                            >
                              The Insured will ensure that all fire alarm and
                              security systems are serviced at least once a year
                              by a professional company and that records of such
                              service are maintained.
                            </li>
                            <li
                              style={{marginBottom: "10px", paddingLeft: "5px"}}
                            >
                              A satisfactory security survey to be carried out
                              within 30 days of inception at the name risk
                              location(s) by surveyors that have been previously
                              agreed by underwriters and all recommendations (if
                              any) being complied with within timeframes
                              specified by insurers.
                            </li>
                          </ul>
                        </li>
                        <li>
                          <h3>Safe warranty:</h3>
                          <ul style={{listStyle: "none"}}>
                            <li
                              style={{marginBottom: "10px", paddingLeft: "5px"}}
                            >
                              It is warranted that 100% of the Insured’s Stock
                              must be held in locked safe approved by Insurers
                              when the Insured’s Premises are closed for
                              business and whenever said Premises are left
                              unattended unless endorsed hereon.
                            </li>
                          </ul>
                        </li>
                        <li style={{marginBottom: "10px", paddingLeft: "5px"}}>
                          <strong>Value / amount limitations:</strong>

                          <ul
                            style={{
                              listStyle: "upper-alpha",
                              paddingLeft: "20px",
                              marginTop: "10px",
                            }}
                          >
                            <li
                              style={{marginBottom: "10px", paddingLeft: "5px"}}
                            >
                              The Underwriters shall not be liable beyond the
                              actual cash value of the property at the time of
                              any loss or damage and the loss or damage shall be
                              ascertained or estimated according to such actual
                              cash value with proper deduction for depreciation,
                              however caused, and shall in no event exceed the
                              lowest figure put upon such property in the
                              Insured's inventories, stock books, stock papers
                              or lists existing at the time the loss or damage
                              occurred, nor the cost to repair or replace the
                              same with material of like kind and quality. Any
                              antiquarian or historical value attaching to the
                              said property shall be excluded from the estimate
                              of loss or damage.
                            </li>
                            <li
                              style={{marginBottom: "10px", paddingLeft: "5px"}}
                            >
                              Claims in respect of loss of or damage to pledged
                              articles shall be limited to the amount actually
                              loaned and unpaid plus the interest thereon at
                              legal rates accrued at date of loss or damage.
                            </li>
                          </ul>
                        </li>

                        <li style={{marginBottom: "10px", paddingLeft: "5px"}}>
                          <strong>
                            {" "}
                            Third party property – loss adjustment and
                            defence:{" "}
                          </strong>
                          <ul style={{listStyle: "none"}}>
                            <li>
                              In case of loss of or damage to property of others
                              held by the Insured, for which claim is made upon
                              the Underwriters, the right to adjust such loss or
                              damage with the owner or owners of the property is
                              reserved to the Underwriters and the receipt of
                              such owner or owners in satisfaction thereof shall
                              be in full satisfaction of any claim of the
                              Insured for which such payment has been made.
                            </li>
                            <li>
                              If legal proceedings be taken to enforce a claim
                              against the Insured as respects any such loss or
                              damage, the Underwriters reserve the right at
                              their option without expense to the Insured, to
                              conduct and control the defence on behalf of and
                              in the name of the Insured.
                            </li>
                            <li>
                              No action of the Underwriters in such regard shall
                              increase the liability of the Underwriters under
                              this Policy, nor increase the limits of liability
                              specified in Section 2 hereof.
                            </li>
                          </ul>
                        </li>
                        <li style={{marginBottom: "10px", paddingLeft: "5px"}}>
                          <strong> Other Insurance: </strong>
                          <ul style={{listStyle: "none"}}>
                            <li>
                              It is understood and agreed that any insurance
                              granted herein shall not cover when there is any
                              other insurance which would attach if this Policy
                              had not been issued, whether such insurance be in
                              the name of the Insured or of any third party.
                            </li>
                            <li>
                              It is however, understood and agreed that, if
                              under the terms of such other insurance (in the
                              absence of this Policy) the liability would be for
                              a less amount than would have been recoverable
                              under this Policy (in the absence of such other
                              policy), then this Policy attaches on the
                              difference.
                            </li>
                          </ul>
                        </li>
                        <li style={{marginBottom: "10px", paddingLeft: "5px"}}>
                          <strong> No benefit to carrier or bailee: </strong>
                          <ul style={{listStyle: "none"}}>
                            <li>
                              This Insurance shall in no way inure directly or
                              indirectly to the benefit of any carrier or other
                              bailee.
                            </li>
                          </ul>
                        </li>
                        <li style={{marginBottom: "10px", paddingLeft: "5px"}}>
                          <strong> Claim Notification: </strong>
                          <ul style={{listStyle: "none"}}>
                            <li>
                              In the event of loss or damage, or of anything
                              likely to result in a claim under this Policy, the
                              Insured shall:
                              <ul style={{listStyle: "none"}}>
                                <li
                                  style={{
                                    marginBottom: "10px",
                                    paddingLeft: "5px",
                                  }}
                                >
                                  A. give immediate notice in writing to the
                                  Underwriters, ADD TPA CONTACT DETAILS
                                  INCLUDING EMAIL
                                </li>
                                <li
                                  style={{
                                    marginBottom: "10px",
                                    paddingLeft: "5px",
                                  }}
                                >
                                  B. protect the property from loss or damage
                                </li>
                                <li
                                  style={{
                                    marginBottom: "10px",
                                    paddingLeft: "5px",
                                  }}
                                >
                                  C. furnish a complete list of the lost or
                                  damaged property stating the market value and
                                  cost of each article and the amount claimed
                                  thereon
                                </li>
                                <li
                                  style={{
                                    marginBottom: "10px",
                                    paddingLeft: "5px",
                                  }}
                                >
                                  D. within sixty (60) days after the loss or
                                  damage (unless such time is extended in
                                  writing by the Underwriters), render to the
                                  Underwriters a proof of loss signed and sworn
                                  to by the Insured, stating the knowledge and
                                  belief of the Insured as to the following:
                                  <ul
                                    style={{
                                      listStyle: "none",
                                      paddingLeft: "20px",
                                    }}
                                  >
                                    <li
                                      style={{
                                        marginBottom: "10px",
                                        paddingLeft: "5px",
                                      }}
                                    >
                                      i. The time and cause of the loss or
                                      damage
                                    </li>
                                    <li
                                      style={{
                                        marginBottom: "10px",
                                        paddingLeft: "5px",
                                      }}
                                    >
                                      ii. The interest of the Insured and of all
                                      others in the property affected
                                    </li>
                                    <li
                                      style={{
                                        marginBottom: "10px",
                                        paddingLeft: "5px",
                                      }}
                                    >
                                      iii. The cash value of each item thereof,
                                      and the amount of loss of or damage
                                      thereto
                                    </li>
                                    <li
                                      style={{
                                        marginBottom: "10px",
                                        paddingLeft: "5px",
                                      }}
                                    >
                                      iv. All encumbrances thereon
                                    </li>
                                    <li
                                      style={{
                                        marginBottom: "10px",
                                        paddingLeft: "5px",
                                      }}
                                    >
                                      v. All other contracts of insurance,
                                      whether valid or not, covering any of such
                                      property and shall furnish a copy of all
                                      the descriptions and schedules in all such
                                      insurance policies if required
                                    </li>
                                  </ul>
                                </li>
                              </ul>
                            </li>
                          </ul>
                        </li>

                        <li style={{marginBottom: "10px", paddingLeft: "5px"}}>
                          <strong> Examination: </strong> The Insured as often
                          as may be reasonably required shall submit, and so far
                          as is within his or their power shall cause all other
                          persons interested in the property and members of
                          their households and employees to submit, to
                          examinations by any persons named by the Underwriters
                          relative to any and all matters in connection with a
                          claim and subscribe the same; and shall produce for
                          examination all books of account, bills, invoices, and
                          other vouchers or certified copies thereof if
                          originals be lost, at such reasonable time and place
                          as may be designated by the Underwriters or their
                          representatives, and shall permit extracts and copies
                          thereof to be made. No such examination or examination
                          of books or documents, nor any other act of the
                          Underwriters or their representatives in connection
                          with the investigation of any loss or damage
                          hereunder, shall be deemed a waiver of any defence
                          which the Underwriters might otherwise have with
                          respect to any such loss or damage, but all such
                          examinations and acts shall be deemed to have been
                          made or done without prejudice to the Underwriters'
                          liability.
                        </li>
                        <li style={{marginBottom: "10px", paddingLeft: "5px"}}>
                          <strong> No abandonment: </strong> There shall be no
                          abandonment to the Underwriters of any property, but
                          the amount of loss or damage for which the
                          Underwriters may be liable shall be payable thirty
                          (30) days after satisfactory proof of loss, as herein
                          provided, is received by the Underwriters.
                        </li>
                        <li style={{marginBottom: "10px", paddingLeft: "5px"}}>
                          <strong> No right of action: </strong> It is
                          understood and agreed that if in case of loss or
                          damage the Insured shall acquire any right of action
                          against any individual, firm or corporation for loss
                          of or damage to the property insured hereunder, the
                          Insured will, if requested by the Underwriters, assign
                          and transfer such claim to the Underwriters or, at the
                          Underwriters' option, execute and deliver to the
                          Underwriters the customary form of loan receipt upon
                          receiving payment for loss or damage or advancement of
                          funds in respect of the loss or damage; and will
                          subrogate the Underwriters to, or will hold in trust
                          for the Underwriters, all rights and demands of every
                          kind, respecting the same, to the extent of the amount
                          paid or advanced, and will permit suit to be brought
                          in the Insured's name at the expense of the
                          Underwriters.
                        </li>
                        <li style={{marginBottom: "10px", paddingLeft: "5px"}}>
                          <strong> Sue & Labour: </strong> In case of any loss
                          or damage of any kind whatsoever, it shall be lawful
                          and necessary, for the Insured or his or their
                          factors, servants or assigns to sue, labour and travel
                          for, in and about the defence, safeguard and recovery
                          of the aforesaid subject matter of this Insurance or
                          any part thereof without prejudice to this Insurance
                          or waiver of the Insured's rights hereunder.
                        </li>
                        <li style={{marginBottom: "10px", paddingLeft: "5px"}}>
                          <strong> Suit limitation: </strong> No suit, action or
                          proceeding for the recovery of any claim under this
                          Policy shall be sustainable in any court of law or
                          equity unless the same be commenced within twelve (12)
                          months next after discovery by the Insured of the
                          occurrence which gives rise to the claim. Provided,
                          however, that if by law such limitation is invalid,
                          then any such claims shall be void unless such action,
                          suit or proceeding be commenced within the shortest
                          limit of time permitted by law to be fixed herein.
                        </li>
                        <li style={{marginBottom: "10px", paddingLeft: "5px"}}>
                          <strong> Premium Payment Clause: </strong>
                          <br />
                          <p style={{marginTop: "10px"}}>
                            Notwithstanding any provision to the contrary within
                            this contract or any endorsement hereto, in respect
                            of nonpayment of premium only the following clause
                            will apply.
                          </p>
                          <p style={{marginTop: "10px"}}>
                            The Insured undertakes that premium will be paid in
                            full to Insurers within sixty (60) days of inception
                            of this contract (or, in respect of instalment
                            premiums, when due). If the premium due under this
                            contract has not been so paid to Insurers by the
                            60th day from the inception of this contract (and,
                            in respect of instalment premiums, by the date they
                            are due), Insurers shall have the right to cancel
                            this contract by notifying the Insured via the
                            broker in writing. In the event of cancellation,
                            premium is due to Insurers on a pro rata basis for
                            the period that Insurers are on risk.
                          </p>
                          <p style={{marginTop: "10px"}}>
                            but the full contract premium shall be payable to
                            Insurers in the event of a loss or occurrence prior
                            to the date of termination which gives rise to a
                            valid claim under this contract.
                          </p>
                          <p style={{marginTop: "10px"}}>
                            It is agreed that Insurers shall give not less than
                            fifteen (15) days prior notice of cancellation to
                            the Insured via the broker. If premium due is paid
                            in full to Insurers before the notice period
                            expires, notice of cancellation shall automatically
                            be revoked. If not, the contract shall automatically
                            terminate at the end of the notice period.
                          </p>
                          <p style={{marginTop: "10px"}}>
                            If any provision of this clause is found by any
                            court or administrative body of competent
                            jurisdiction to be invalid or unenforceable, such
                            invalidity or unenforceability will not affect the
                            other provisions of this clause which will remain in
                            full force and effect.
                          </p>
                          <strong style={{marginTop: "10px", display: "block"}}>
                            LSW3001
                          </strong>
                        </li>

                        <li style={{marginBottom: "10px", paddingLeft: "5px"}}>
                          <strong>
                            {" "}
                            Cancellation (other than for non payment of
                            premium):{" "}
                          </strong>
                          <p style={{marginTop: "5px"}}>
                            This Policy may be cancelled at any time at the
                            written request of the Insured. This Policy may also
                            be cancelled, with or without the return or tender
                            of the unearned premium, by or on behalf of the
                            Underwriters by mailing to the Insured at the
                            address shown in this Policy or last known address
                            written notice stating when, not less than fifteen
                            (15) days thereafter, such cancellation shall be
                            effective.
                          </p>
                        </li>
                        <li style={{marginBottom: "10px", paddingLeft: "5px"}}>
                          <strong> Fraudulent Claims: </strong>
                          <p style={{marginTop: "5px"}}>
                            If the Insured shall make any claim knowing the same
                            to be false or fraudulent, as regards amount or
                            otherwise, this Policy shall become void and all
                            claim hereunder shall be forfeited.
                          </p>
                        </li>
                        <li style={{marginBottom: "10px", paddingLeft: "5px"}}>
                          <strong>
                            {" "}
                            Termination of transit clause (Terrorism) - Whilst
                            in the Ordinary Course of Transit:{" "}
                          </strong>
                          <ul
                            style={{
                              listStyle: "upper-alpha",
                              paddingLeft: "20px",
                            }}
                          >
                            <li
                              style={{marginBottom: "10px", paddingLeft: "5px"}}
                            >
                              It is understood and agreed that for insured
                              property in the ordinary course of transit, this
                              insurance covers loss of our damage to the insured
                              property caused by any act of terrorism being an
                              act of any person acting on behalf of, or in
                              connection with, any organisation which carries
                              out activities directed towards the overthrowing
                              or influencing, by force or violence, of any
                              government whether or not legally constituted or
                              any person acting from a political, ideological or
                              religious motive, and in any event, SHALL
                              TERMINATE: either,
                              <ul
                                style={{
                                  listStyle: "lower-roman",
                                  marginTop: "10px",
                                  paddingLeft: "20px",
                                }}
                              >
                                <li
                                  style={{
                                    marginBottom: "10px",
                                    paddingLeft: "15px",
                                  }}
                                >
                                  {" "}
                                  As per the transit clauses contained within
                                  the contract of insurance; or
                                </li>
                                <li
                                  style={{
                                    marginBottom: "10px",
                                    paddingLeft: "15px",
                                  }}
                                >
                                  {" "}
                                  on completion of unloading from the carrying
                                  vehicle or other conveyance in or at the final
                                  warehouse or place of storage at the
                                  destination named in the contract of
                                  insurance; or
                                </li>
                                <li
                                  style={{
                                    marginBottom: "10px",
                                    paddingLeft: "15px",
                                  }}
                                >
                                  {" "}
                                  on completion of unloading from the carrying
                                  vehicle or other conveyance in or at any other
                                  warehouse or place of storage, whether prior
                                  to or at the destination names in the contract
                                  of insurance, which the Assured or their
                                  employees elect to use either for storage
                                  other than in the ordinary course of transit
                                  or for allocation or distribution; or
                                </li>
                                <li
                                  style={{
                                    marginBottom: "10px",
                                    paddingLeft: "15px",
                                  }}
                                >
                                  when the Assured or their employees elect to
                                  use any carrying vehicle or other conveyance
                                  or any container for storage other than in the
                                  ordinary course of transit; or
                                </li>
                                <li
                                  style={{
                                    marginBottom: "10px",
                                    paddingLeft: "15px",
                                  }}
                                >
                                  {" "}
                                  on completion of unloading from the carrying
                                  vehicle or other conveyance in or at any other
                                  warehouse or place of storage, whether prior
                                  to or at the destination named in the Contract
                                  of
                                  <p style={{marginTop: "10px"}}>
                                    Insurance, which the Assured or their
                                    employees elect to use either for storage
                                    other than in the ordinary course of transit
                                    or for allocation or distribution; or{" "}
                                  </p>
                                </li>
                                <li
                                  style={{
                                    marginBottom: "10px",
                                    paddingLeft: "15px",
                                  }}
                                >
                                  {" "}
                                  in respect of air transits, on the expiry of
                                  30 days after unloading the subject matter
                                  insured from the aircraft at the final place
                                  of discharge. whichever shall first occur.
                                </li>
                              </ul>
                              <li
                                style={{
                                  marginBottom: "10px",
                                  paddingLeft: "5px",
                                }}
                              >
                                If this contract of insurance or the Clauses
                                referred to therein specifically provide cover
                                for inland or other further transits following
                                on from storage, or termination as provided for
                                above, cover will reattach, and continues during
                                the ordinary course of that transit terminating
                                again in accordance with clause.
                              </li>
                            </li>
                          </ul>
                        </li>

                        <li style={{marginBottom: "10px", paddingLeft: "5px"}}>
                          <strong>Choice of Law & Jurisdiction : </strong>
                          Any dispute between the Insured and Insurers relating
                          to this contract or to a claim hereon shall be
                          governed by the law and practice of the State of New
                          York and the provisions of the contract shall be
                          interpreted and construed in accordance with such law
                          and practice. Any and all claims or disputes and any
                          non-contractual obligations arising out of or in
                          connection with this contract shall be subject to the
                          exclusive jurisdiction of the courts of the State of
                          New York.
                        </li>
                        <li style={{marginBottom: "10px", paddingLeft: "5px"}}>
                          <strong>Service of Suit (U.S.A) : </strong>

                          <p style={{marginTop: "5px"}}>
                            This Service of Suit Clause will not be read to
                            conflict with or override the obligations of the
                            parties to arbitrate their disputes as provided for
                            in any Arbitration provision within this Policy.
                            This Clause is intended as an aid to compelling
                            arbitration or enforcing such arbitration or
                            arbitral award, not as an alternative to such
                            Arbitration provision for resolving disputes arising
                            out of this contract of insurance (or reinsurance).
                          </p>
                          <ul style={{listStyle: "none"}}>
                            <li style={{marginTop: "10px", paddingLeft: "5px"}}>
                              It is agreed that in the event of the failure of
                              the Underwriters hereon to pay any amount claimed
                              to be due hereunder, the Underwriters hereon, at
                              the request of the Insured (or Reinsured), will
                              submit to the jurisdiction of a Court of competent
                              jurisdiction within the United States. Nothing in
                              this Clause constitutes or should be understood to
                              constitute a waiver of Underwriters rights to
                              commence an action in any Court of competent
                              jurisdiction in the United States, to remove an
                              action to a United States District Court, or to
                              seek a transfer of a case to another Court as
                              permitted by the laws of the United States or of
                              any State in the United States.
                            </li>
                            <li style={{marginTop: "10px", paddingLeft: "5px"}}>
                              It is further agreed that service of process in
                              such suit may be made upon for Convex Insurance UK
                              Limited and any other Non-Lloyd’s following
                              Underwriters, through the party as set out below:
                              Troutman Pepper Locke LLP, 875 Third Avenue, New
                              York, NY 10022, Attention: Zachary Lerner
                            </li>
                            <li style={{marginTop: "10px", paddingLeft: "5px"}}>
                              and, for any following Lloyd’s underwriters
                              through the party as set out below: Lloyd’s
                              America, Inc., Attention: Legal Department. 280
                              Park Avenue, East Tower, 25th Floor, New York, NY
                              10017 and that in any suit instituted against any
                              one of them upon this contract, Underwriters will
                              abide by the final decision of such Court or of
                              any Appellate Court in the event of an appeal.
                            </li>
                            <li style={{marginTop: "10px", paddingLeft: "5px"}}>
                              The above-named are authorized and directed to
                              accept service of process on behalf of
                              Underwriters in any such suit and/or upon the
                              request of the insured (or Reinsured) to give a
                              written undertaking to the insured (or Reinsured)
                              that they will enter a general appearance upon
                              Underwriters behalf in the event such a suit shall
                              be instituted.
                            </li>
                            <li style={{marginTop: "10px", paddingLeft: "5px"}}>
                              Further, pursuant to any statute of any state,
                              territory or district of the United States which
                              makes provision therefore, Underwriters hereon
                              hereby designate the Superintendent, Commissioner
                              or Director of insurance or other officer
                              specified for that purpose in the statute, or his
                              successor or successors in office, as their true
                              and lawful attorney upon whom may be served any
                              lawful process in any action, suit or proceeding
                              instituted by or on behalf of the Insured (or
                              Reinsured) or any beneficiary hereunder arising
                              out of this contract of insurance (or
                              reinsurance), and hereby designate the above-named
                              as the person to whom the said officer is
                              authorized to mail such process or a true copy
                              thereof.
                            </li>
                          </ul>
                        </li>

                        <li style={{marginBottom: "10px", paddingLeft: "5px"}}>
                          <strong>Sanctions Suspension Clause : </strong>
                          It is a condition of this (re)insurance, and the
                          (re)insured agrees, that the provision of any cover,
                          the payment of any claim and the provision of any
                          benefit hereunder shall be suspended, to the extent
                          that the provision of such cover, payment of such
                          claim or provision of such benefit by the (re)insurer
                          would expose that (re)insurer to any sanction,
                          prohibition or restriction under any:
                          <ul style={{listStyle: "none", marginTop: "10px"}}>
                            <li
                              style={{marginBottom: "10px", paddingLeft: "5px"}}
                            >
                              a) United Nations’ resolution(s); or
                            </li>
                            <li
                              style={{marginBottom: "10px", paddingLeft: "5px"}}
                            >
                              b) the trade or economic sanctions, laws or
                              regulations of the European Union, United Kingdom
                              or United States of America.
                            </li>
                          </ul>
                          <p style={{marginBottom: "10px"}}>
                            {" "}
                            Such suspension shall continue until such time as
                            the (re)insurer would no longer be exposed to any
                            such sanction, prohibition or restriction.
                          </p>
                          <strong>LMA3200</strong>
                          <br />
                          <strong>05 October 2023</strong>
                        </li>

                        <li style={{marginBottom: "10px", paddingLeft: "5px"}}>
                          <strong>Personal conveyance clause:</strong> This
                          insurance covers the property insured in transit only
                          when the ‘close personal custody and control’ of an
                          individual designated in this insurance and subject to
                          the individual limitations as specified in the
                          Schedule. For the purpose of this clause, ‘close
                          personal custody and control’ means that the property
                          insured shall be held by, or attached to, or within
                          sight and not more than arm’s length reach of the
                          designated individual at all times whilst in transit.
                          A negligent or voluntary relinquishment of ‘close
                          personal custody and control’ over the property
                          insured by the designated individual will not
                          constitute a loss for the purposes of recovery
                          hereunder and will result in an immediate cessation of
                          coverage.
                          <ul style={{listStyle: "none", marginTop: "10px"}}>
                            <li
                              style={{marginBottom: "10px", paddingLeft: "5px"}}
                            >
                              When the property insured is being carried in a
                              vehicle, the definition of ‘close personal custody
                              and control’ is extended to include the locked
                              boot or trunk of said vehicle but subject always
                              to Exclusion I.
                            </li>
                            <li
                              style={{marginBottom: "10px", paddingLeft: "5px"}}
                            >
                              When the property insured is being carried onboard
                              an airplane, the definition of ‘close personal
                              custody and control’ is extended to include the
                              overhead lockers within the passenger cabin.
                            </li>
                            <li
                              style={{marginBottom: "10px", paddingLeft: "5px"}}
                            >
                              When the property insured is being carried within
                              the customs-controlled area at the Airport, ‘close
                              personal control and custody’ clause shall not
                              apply during security inspection and temporary
                              custody of customs.
                            </li>
                          </ul>
                        </li>

                        <li style={{marginBottom: "10px", paddingLeft: "5px"}}>
                          <strong>Deductible clause:</strong>
                          <p style={{marginTop: "10px", marginBottom: "10px"}}>
                            {" "}
                            In consideration of the reduced premium charged,
                            each and every loss or series of losses arising from
                            the same event, shall be adjusted separately and
                            from the amount of each adjusted claim or the
                            applicable limit of liability, whichever is the
                            less, the following sum shall be deducted:
                          </p>
                          <p style={{marginBottom: "10px"}}>
                            USD 5,000 for loss or damage occurring On-premises
                            and <strong>USD 5,000</strong> for loss or damage
                            occurring Off Premises.
                          </p>
                          <p style={{marginBottom: "10px"}}>
                            {" "}
                            It is a condition of this Policy that the
                            deductibles specified above shall be solely at the
                            risk of the Insured and shall not be covered under
                            any other policy of insurance effected in the name
                            of the Insured.
                          </p>
                          In the event of any recovery or salvage on a loss
                          which has been or is being or is about to be paid
                          hereunder, such recovery or salvage shall accrue
                          entirely to the benefit of the Underwriters under this
                          policy until the sum paid by them has been made up.
                        </li>

                        <li style={{marginBottom: "10px", paddingLeft: "5px"}}>
                          <strong>Deductible amendment clause:</strong>
                          <br />
                          It is understood and agreed that the Deductible is
                          further decreased to <strong>USD 1,000</strong> in
                          respect of Sendings.
                        </li>

                        <li style={{marginBottom: "10px", paddingLeft: "5px"}}>
                          <strong>Representative clause:</strong>
                          <br />
                          It is understood and agreed that for the purposes of
                          this Insurance the term "representatives" shall be
                          deemed to mean a person designated by the Assured who:
                          <ul
                            style={{
                              listStyle: "upper-alpha",
                              paddingLeft: "20px",
                              marginTop: "10px",
                            }}
                          >
                            <li
                              style={{marginBottom: "10px", paddingLeft: "5px"}}
                            >
                              {" "}
                              is of a minimum age of 21 years.
                            </li>
                            <li
                              style={{marginBottom: "10px", paddingLeft: "5px"}}
                            >
                              {" "}
                              has at least 2 years experience in the trade.
                            </li>
                            <li
                              style={{marginBottom: "10px", paddingLeft: "5px"}}
                            >
                              {" "}
                              has not suffered any previous losses.
                            </li>
                            <li
                              style={{marginBottom: "10px", paddingLeft: "5px"}}
                            >
                              {" "}
                              is in the permanent and exclusive employment of
                              the Assured and/or subsidiary and/or associated
                              company.
                            </li>
                          </ul>
                          It is a condition precedent to any liability under
                          this Insurance that such designated person is not
                          carrying goods for any other party.
                        </li>

                        <li style={{marginBottom: "10px", paddingLeft: "5px"}}>
                          <strong>Deemed employee clause:</strong>
                          <br />
                          It is hereby understood and agreed that (names of the
                          individuals) are deemed to be employees of the Assured
                          for the purpose of this insurance.
                        </li>

                        <li style={{marginBottom: "10px", paddingLeft: "5px"}}>
                          <strong>Cross fidelity clause:</strong>
                          <br /> It is hereby understood and agreed by
                          Underwriters that for the purposes of this Contract
                          that the owners, officers, principals, employees,
                          representatives, travelers, and/or agents of (Company
                          Name), who share the premises with the Insured, are
                          deemed to be employees of the Insured.
                        </li>

                        <li style={{marginBottom: "10px", paddingLeft: "5px"}}>
                          <strong>Waiver of subrogation clause:</strong>
                          <br />
                          It is hereby understood and agreed that the Insured
                          shall be at liberty to enforce or not, as they please,
                          any rights that they may have against customers and/or
                          persons authorized by the Insured to wear and/or carry
                          the property Insured and on their behalf and/or
                          persons or companies to whom the Insured has entrusted
                          property insured in respect of any loss or damage
                          occurring hereunder in respect of Auction Houses
                          and/or Gemological Laboratories only.
                        </li>

                        <li style={{marginBottom: "10px", paddingLeft: "5px"}}>
                          <strong>Supplemental coverage endorsement:</strong>
                          <br />
                          (applicable only when the Contract includes coverage
                          under Sections 1D of the Schedule within Risk
                          Details).
                          <ul style={{listStyle: "none", marginTop: "10px"}}>
                            <li
                              style={{marginBottom: "10px", paddingLeft: "5px"}}
                            >
                              <strong>A. INTEREST EXCLUDED:</strong> This
                              Contract does not apply to street clocks, other
                              clocks, electrical or mechanical signs, not
                              located within the building; exterior glass and
                              any lettering or ornamentation thereon including
                              glass of outside showcases; architect fees; cost
                              of excavations; underground flues, pipes, wiring,
                              drains, brick, stone or concrete foundations;
                              piers or other supports below the under surface of
                              the lowest basement floor or where there is no
                              basement which are below the surface of the
                              ground; land values.
                            </li>
                            <li
                              style={{marginBottom: "10px", paddingLeft: "5px"}}
                            >
                              <strong>B. PERILS EXCLUDED:</strong> As to
                              Interest covered by this endorsement, this
                              Contract does not insure against:
                              <ul
                                style={{listStyle: "none", marginTop: "10px"}}
                              >
                                <li
                                  style={{
                                    marginBottom: "10px",
                                    paddingLeft: "5px",
                                  }}
                                >
                                  1. breakage of interior glass unless caused by
                                  fire, lightning (provided such perils are
                                  covered by this Contract), burglary, theft,
                                  windstorm, hail, riot attending a strike,
                                  civil commotion, explosion, smoke, aircraft,
                                  land vehicles, vandalism, malicious mischief
                                  or sprinkler leakage;
                                </li>
                                <li
                                  style={{
                                    marginBottom: "10px",
                                    paddingLeft: "5px",
                                  }}
                                >
                                  2. loss or damage caused by wear and tear,
                                  mechanical breakdown or latent defect; or
                                  short-circuit, blow-out, or other electrical
                                  disturbance within any article insured
                                  hereunder, unless fire or explosion.
                                  <p>
                                    ensues, and then only for direct loss or
                                    damage caused by such ensuing fire,
                                    (provided such peril is covered by this
                                    Contract) or explosion.
                                  </p>
                                </li>
                              </ul>
                            </li>

                            <li
                              style={{marginBottom: "10px", paddingLeft: "5px"}}
                            >
                              <strong>C. SPECIAL CONDITIONS:</strong>
                              <br />
                              Improvements and Betterments.
                              <p style={{marginTop: "10px"}}>
                                In the event tenant's improvements and
                                betterments covered hereunder are damaged or
                                destroyed by a peril not excluded, this Contract
                                covers the Insured's interest therein and the
                                liability of the Insurers shall be determined as
                                follows:
                              </p>
                              <ul
                                style={{listStyle: "none", marginTop: "10px"}}
                              >
                                <li
                                  style={{
                                    marginBottom: "10px",
                                    paddingLeft: "5px",
                                  }}
                                >
                                  If repaired or replaced at the expense of the
                                  Insured within a reasonable time after such
                                  loss, the actual cash value of the damaged or
                                  destroyed Interest;
                                </li>
                                <li
                                  style={{
                                    marginBottom: "10px",
                                    paddingLeft: "5px",
                                  }}
                                >
                                  2. If not repaired or replaced within a
                                  reasonable time after such loss, that
                                  proportion of the original cost of the damaged
                                  or destroyed Interest which the unexpired term
                                  of the lease or rental agreement (whether
                                  written or oral, in effect as of the time of
                                  the loss) on the date of the loss bears to the
                                  period(s) from the date(s) the Interest was
                                  installed to the expiration date of such lease
                                  or rental agreement;
                                </li>
                                <li
                                  style={{
                                    marginBottom: "10px",
                                    paddingLeft: "5px",
                                  }}
                                >
                                  3. If repaired or replaced at the expense of
                                  others for the use of the Insured, there shall
                                  be no liability hereunder.
                                  <p style={{marginTop: "10px"}}>
                                    The Insurers shall not be liable for any
                                    increased cost of repairs or reconstruction
                                    by reason of any law, ordinance, regulation,
                                    permit, or license regulating construction
                                    or repair.
                                  </p>
                                  <p style={{marginTop: "10px"}}>
                                    If the Insured shall be deprived of the
                                    right of occupancy of the premises because
                                    of physical loss or damage thereto from a
                                    peril insured, the Insurers' liability shall
                                    be limited to the proportion of the value of
                                    the improvements and betterments on the date
                                    of loss which is equivalent to the actual
                                    loss sustained by reason of the termination
                                    of occupancy.
                                  </p>
                                  <p style={{marginTop: "10px"}}>
                                    <strong>Valuation.</strong> The Insurers
                                    shall not be liable beyond the actual cash
                                    value of the Interest at the time any loss
                                    or damage occurs and the loss or damage
                                    shall be ascertained or estimated according
                                    to such actual cash value with proper
                                    deduction for depreciation, however caused,
                                    and shall in no event exceed what it would
                                    then cost to repair or replace the same with
                                    material of like kind and quality.
                                  </p>
                                  <p style={{marginTop: "10px"}}>
                                    <strong>Appraisal.</strong> If the Insured
                                    and the Insurers fail to agree as to the
                                    amount of loss, each shall, on the written
                                    demand, of either, made within sixty (60)
                                    days after receipt of proof of loss by the
                                    Insurers, select a competent and
                                    disinterested appraiser, and the appraisal
                                    shall be made at a reasonable time and
                                    place. The appraisers shall first select a
                                    competent and disinterested umpire, and
                                    failing for fifteen (15) days to agree upon
                                    such umpire, then, on the request of the
                                    Insured or the Insurers, such umpire shall
                                    be selected by a judge of a court of record
                                    in the state in which such appraisal is
                                    pending. The appraisers shall then appraise
                                    the loss, stating separately the actual cash
                                    value at the time of loss and the amount of
                                    loss, and failing to agree shall submit
                                    their differences to the umpire. An award in
                                    writing of any two shall determine the
                                    amount of loss. The Insured and the Insurers
                                    shall each pay his or their chosen appraiser
                                    and shall bear equally the other expenses of
                                    the appraisal and umpire. The Insurers shall
                                    not be held to have waived any of their
                                    rights by any act relating to appraisal.
                                  </p>
                                </li>
                              </ul>
                            </li>
                          </ul>
                        </li>

                        <li style={{marginBottom: "10px", paddingLeft: "5px"}}>
                          <strong>
                            {" "}
                            Joint ownership/joint venture clause:
                          </strong>
                          <p>
                            This policy is extended to cover in full the
                            interest which the Insured and any other person(s)
                            or firm(s) own in joint account irrespective of
                            whether or not this joint account ownership is based
                            on written or oral agreement and irrespective of the
                            assured having signed a memorandum. It is being
                            understood and agreed that when such merchandise is
                            in the custody and/or possession or responsibility
                            of the assured and/or representatives of the assured
                            or such merchandise has been given out on memo by
                            the insured, such merchandise is covered hereunder
                            in full. When such joint merchandise is in the
                            control of the joint owner this policy covers only
                            the Insureds interest.
                          </p>
                        </li>

                        <li style={{marginBottom: "10px", paddingLeft: "5px"}}>
                          <strong>Connecting conveyance clause:</strong> This
                          Insurance includes the Connecting Personal Conveyance
                          by the Consignor and/or Consignee and/or their
                          employees not exceeding the limit of the main method
                          of conveyances stated in the Schedule of Insured
                          Limits but not exceeding USD 500,000 Within USA.
                        </li>

                        <li style={{marginBottom: "10px", paddingLeft: "5px"}}>
                          <strong>Basis of valuation amendment clause:</strong>
                          <p style={{marginTop: "10px"}}>
                            {" "}
                            Loss if any, will be based on the insured’s computer
                            inventory list price where available or private
                            books and records where there is no computer
                            inventory.
                          </p>
                          <p style={{marginTop: "10px"}}>
                            {" "}
                            Valuation is per item less 15% (of wholesale selling
                            price) to arrive to the insured’s stated cost.
                          </p>
                          <p style={{marginTop: "10px"}}>
                            The computer printout or private books and records
                            plus any purchases and/or sales after the printout
                            date, are the only records required.
                          </p>
                          <p style={{marginTop: "10px"}}>
                            Total Policy Amount <strong> USD 5,000,000 </strong>
                          </p>
                        </li>

                        <li style={{marginBottom: "10px", paddingLeft: "5px"}}>
                          <strong>EXTENSIONS</strong>
                          <ul
                            style={{
                              listStyle: "upper-alpha",
                              paddingLeft: "20px",
                              marginTop: "10px",
                            }}
                          >
                            <li
                              style={{marginBottom: "10px", paddingLeft: "5px"}}
                            >
                              <strong>
                                {" "}
                                Theft damage to occupied premises extension:
                              </strong>{" "}
                              <br />
                              To the extent of 10% of the Limit of Liability
                              stated in Section 2A as applicable at such
                              premises, the Underwriters will pay for damage
                              (except by fire) to that part of the building
                              occupied by the Insured directly resulting from
                              theft or any attempt thereat, provided the Insured
                              is the owner of such premises or is legally liable
                              for such damage; but in no event shall this
                              extension apply to glass or to any lettering or
                              ornamentation thereon. The Underwriters' combined
                              liability under this extension and under Item A of
                              Section 2 shall not exceed the amount of insurance
                              shown under Item A of Section 2 for the premises
                              at which such loss or damage occurs.
                            </li>

                            <li
                              style={{marginBottom: "10px", paddingLeft: "5px"}}
                            >
                              <strong> Exhibition extension clause:</strong>{" "}
                              <br /> Notwithstanding anything contained in
                              Exclusion 5(J) to the contrary, it is hereby
                              understood and agreed that this insurance is
                              extended to cover property insured whilst at
                              Exhibitions in the United States of America
                              subject to a Maximum Limit of Liability of USD
                              5,000,000 Any One Exhibition, or as agreed by the
                              Leading Insurer(s) and USD 20,000,000 in the
                              aggregate of the policy term.
                              <p style={{marginTop: "10px"}}>
                                {" "}
                                The property of the Insured and/or that for
                                which the Insured is responsible, shall:
                              </p>
                              <ul
                                style={{listStyle: "none", marginTop: "10px"}}
                              >
                                <li
                                  style={{
                                    marginBottom: "10px",
                                    paddingLeft: "5px",
                                  }}
                                >
                                  1. Never be left unattended, for any reason
                                  whatsoever, whilst on display during
                                  Exhibition hours.
                                </li>
                                <li
                                  style={{
                                    marginBottom: "10px",
                                    paddingLeft: "5px",
                                  }}
                                >
                                  2. At all times be kept in locked showcases
                                  with keys removed, cabinets, drawers and/or
                                  safes whilst on display during Exhibition
                                  hours, unless being removed or returned to
                                  such showcases, drawers and/or safes.
                                </li>
                                <li
                                  style={{
                                    marginBottom: "10px",
                                    paddingLeft: "5px",
                                  }}
                                >
                                  3. Be kept in a locked safe/vault or approved
                                  security room at all times when not being
                                  displayed.
                                </li>
                              </ul>
                              <p style={{marginBottom: "10px"}}>
                                If the Insured violates any of the above terms
                                and conditions of this Clause, the Insured's
                                right of recovery hereunder shall be entirely
                                void and no claim will be paid.
                              </p>
                              <p>
                                It is understood and agreed that the Limit of
                                Liability 2(B)1 is extended to include the
                                transit of property insured by armoured car
                                carrier to/from the above exhibitions for the
                                above Limits of Liability.
                              </p>
                            </li>

                            <li
                              style={{marginBottom: "10px", paddingLeft: "5px"}}
                            >
                              <strong>
                                {" "}
                                Exhibitions: carrying at exhibitions extension
                                clause:
                              </strong>
                              <p style={{marginBottom: "10px"}}>
                                It is hereby understood and agreed that in
                                respect of Limitation of Liability Section 2(E)
                                herein and subject to the Limits(s) therein
                                contained, Exclusion J is hereby amended to
                                allow the persons named in the attached proposal
                                under the off-premises section to visit on the
                                premises of any official exhibition of the
                                diamond, gemstones and/or jewelry trade
                                including those promoted or financially assisted
                                by any public authority or by any diamond,
                                gemstones and/or jewelry trade association where
                                they are not actually participating as an
                                exhibitor.
                              </p>
                              <p style={{marginBottom: "10px"}}>
                                No accumulation of limits of two or more
                                travellers at the Exhibition.
                              </p>
                              <p>
                                The maximum liability of Underwriters resulting
                                from any one loss shall be subject to the
                                individual travel limit of the officers of the
                                corporation, member of the firm, employees
                                and/or commissioned salespeople as specified in
                                Limitation of Liability Section 2(E).
                              </p>
                            </li>

                            <li
                              style={{marginBottom: "10px", paddingLeft: "5px"}}
                            >
                              <strong>Hotel/motel exclusion clause:</strong>
                              <br />
                              It is understood and agreed that this Policy will
                              exclude all risks of loss of or damage to the
                              Property Insured if left unattended whilst in the
                              premises of hotels or motels unless the Property
                              Insured is contained in the principal hotel or
                              motel safe or vault and/or safe deposit box of
                              hotels or motels.
                            </li>

                            <li
                              style={{marginBottom: "10px", paddingLeft: "5px"}}
                            >
                              <strong> Memorandum extension clause:</strong>
                              <br />
                              Notwithstanding anything contained in Exclusion J
                              of this Insurance to the contrary, it is hereby
                              understood and agreed that this Insurance is
                              extended to include goods on Memorandum whilst at
                              Exhibitions within the US subject to the property
                              insured:
                              <ul
                                style={{listStyle: "none", marginTop: "10px"}}
                              >
                                <li
                                  style={{
                                    marginBottom: "10px",
                                    paddingLeft: "5px",
                                  }}
                                >
                                  1. Never be left unattended, for any reason
                                  whatsoever, whilst on display during
                                  exhibition hours,
                                </li>
                                <li
                                  style={{
                                    marginBottom: "10px",
                                    paddingLeft: "5px",
                                  }}
                                >
                                  2. At all times be kept in key locked
                                  showcases with keys removed, whilst on display
                                  during exhibition hours other than whilst
                                  being taken therefrom or being replaced
                                  therein for the purposes of showing to
                                  customers,
                                </li>
                                <li
                                  style={{
                                    marginBottom: "10px",
                                    paddingLeft: "5px",
                                  }}
                                >
                                  3. Be always kept in a locked safe/vault or
                                  approved security room outside exhibition
                                  hours.
                                </li>
                              </ul>
                            </li>

                            <li
                              style={{marginBottom: "10px", paddingLeft: "5px"}}
                            >
                              <strong>F. No claims bonus:</strong> <br />
                              <p style={{marginBottom: "10px"}}>
                                It is hereby understood and agreed that
                                Underwriters agree to allow a Return Premium of
                                10% Net Absolute of the premium charged herein,
                                payable at expiry subject to no known or
                                reported losses during the period of Insurance
                                and renewed with existing Underwriters.
                              </p>
                              <p>
                                In the event an Insurer declines to offer
                                renewal terms or elects not to participate in
                                the renewal or replacement of the market program
                                structure used to underwrite this contract, such
                                insurer shall remain liable for their proportion
                                of the no claims bonus.
                              </p>
                            </li>

                            <li
                              style={{marginBottom: "10px", paddingLeft: "5px"}}
                            >
                              <strong> Safekeeping extension clause:</strong>
                              <br />
                              It is understood and agreed that Property Insured
                              under Section 2(E) of this Policy is covered
                              hereunder whilst deposited for safekeeping with
                              others whether whilst traveling or not.
                            </li>

                            <li
                              style={{marginBottom: "10px", paddingLeft: "5px"}}
                            >
                              <strong>
                                {" "}
                                Incoming sendings extension clause:
                              </strong>
                              <br />
                              It is hereby understood and agreed that this
                              Insurance is extended to insure shipments made to
                              the Insured by any third party, provided however
                              that any such shipment has been approved by the
                              Insured PRIOR to dispatch by the third party
                              making the shipment and also that the method being
                              used is covered by this Insurance and that all
                              this Insurance’s terms, sub-limits, conditions and
                              restrictions have been met and complied with,
                              including the Territorial Exclusion.
                            </li>

                            <li
                              style={{marginBottom: "10px", paddingLeft: "5px"}}
                            >
                              <strong> Excess shipments clause:</strong>
                              <br />
                              It is hereby understood and agreed that any
                              Shipments coverage under this Insurance is in
                              excess of any coverage purchased from the shipper
                              and/or carrier.
                            </li>

                            <li
                              style={{marginBottom: "10px", paddingLeft: "5px"}}
                            >
                              <strong>
                                {" "}
                                Express shipments extension clause:
                              </strong>
                              <br />
                              The following conditions are precedent to
                              Underwriters liability in respect of shipments by
                              Express couriers:
                              <ul
                                style={{listStyle: "none", marginTop: "10px"}}
                              >
                                <li
                                  style={{
                                    marginBottom: "10px",
                                    paddingLeft: "5px",
                                  }}
                                >
                                  <strong> 1. </strong> You must use a box with
                                  minimum dimensions of 11 ¼” X 11 ¼” X 1 1/8”.
                                  <ul
                                    style={{
                                      listStyle: "none",
                                      marginTop: "10px",
                                    }}
                                  >
                                    <li
                                      style={{
                                        marginBottom: "10px",
                                        paddingLeft: "5px",
                                      }}
                                    >
                                      a) The Air-bill &amp;/or ownership label
                                      shall make no reference to precious
                                      commodities such as gold, diamonds,
                                      jewellery.
                                    </li>
                                    <li
                                      style={{
                                        marginBottom: "10px",
                                        paddingLeft: "5px",
                                      }}
                                    >
                                      b) No values are to be declared on the
                                      Air-bill.
                                    </li>
                                  </ul>
                                  Conditions 1.a) and 2.b) shall not apply if a
                                  declaration of value or contents must be made
                                  to customs or if statutory regulations require
                                  otherwise.
                                </li>

                                <li
                                  style={{
                                    marginBottom: "10px",
                                    paddingLeft: "5px",
                                  }}
                                >
                                  <strong> 2. </strong> Coverage will be in
                                  excess of insurance provided by the carrier
                                  and/or purchased from the carrier but maximum
                                  liability under the policy cannot exceed the
                                  Limit as specified in the schedule.
                                </li>

                                <li
                                  style={{
                                    marginBottom: "10px",
                                    paddingLeft: "5px",
                                  }}
                                >
                                  <strong>3.</strong> Package(s) must either:
                                  <ul
                                    style={{
                                      marginTop: "10px",
                                      listStyle: "none",
                                    }}
                                  >
                                    <li
                                      style={{
                                        marginBottom: "10px",
                                        paddingLeft: "5px",
                                      }}
                                    >
                                      a) Be delivered to a manned and/or staffed
                                      office of the carrier and a receipt
                                      obtained or package should be scanned in
                                      front of you.
                                    </li>
                                    <li
                                      style={{
                                        marginBottom: "10px",
                                        paddingLeft: "5px",
                                      }}
                                    >
                                      b) Be picked up from the Insured’s
                                      premises by the overnight carrier’s
                                      personnel on production of proper Photo
                                      ID.
                                    </li>
                                  </ul>
                                  Unmanned and/or unstaffed collection points
                                  and/or drop boxes MUST NOT be used.
                                </li>
                              </ul>
                            </li>

                            <li
                              style={{marginBottom: "10px", paddingLeft: "5px"}}
                            >
                              <strong>
                                Confiscation and expropriation extension clause:
                              </strong>
                              <ul style={{listStyle: "num"}}>
                                <li
                                  style={{
                                    marginBottom: "10px",
                                    paddingLeft: "5px",
                                  }}
                                >
                                  <ul
                                    style={{
                                      listStyle: "none",
                                      marginTop: "10px",
                                    }}
                                  >
                                    <li
                                      style={{
                                        marginBottom: "10px",
                                        paddingLeft: "5px",
                                      }}
                                    >
                                      (a) This insurance is to cover loss of
                                      and/or damage to the property hereby
                                      insured in the course of transit directly
                                      caused by confiscation, seizure,
                                      appropriation, expropriation, requisition
                                      for title or use or wilful destruction by
                                      or under the order of the Government
                                      (whether civil, military or de facto)
                                      and/or public or local authority of the
                                      country or place in which the vessel(s),
                                      craft, property hereby insured are covered
                                      by the terms of this insurance.
                                    </li>
                                    <li
                                      style={{
                                        marginBottom: "10px",
                                        paddingLeft: "5px",
                                      }}
                                    >
                                      (b) Nevertheless, this insurance does not
                                      cover any such loss or damage by or under
                                      the order of the government and/or public
                                      or local authority of the country of
                                      despatch.
                                    </li>
                                    <li
                                      style={{
                                        marginBottom: "10px",
                                        paddingLeft: "5px",
                                      }}
                                    >
                                      (c) In respect of such property as may be
                                      insured hereunder where limitation or
                                      exclusion of war coverage is made by the
                                      appropriate Institute War Clause or by any
                                      other clause, such limitation or exclusion
                                      of war coverage shall also apply to this
                                      Extension.
                                    </li>
                                  </ul>
                                </li>

                                <li
                                  style={{
                                    marginBottom: "10px",
                                    paddingLeft: "5px",
                                  }}
                                >
                                  <ul
                                    style={{
                                      listStyle: "none",
                                      marginTop: "10px",
                                    }}
                                  >
                                    <li
                                      style={{
                                        marginBottom: "10px",
                                        paddingLeft: "5px",
                                      }}
                                    >
                                      (a) No claim to attach hereto for any loss
                                      arising from any debt, failure to provide
                                      bond or security, or any other financial
                                      cause, whether under court order or
                                      otherwise.
                                    </li>
                                    <li
                                      style={{
                                        marginBottom: "10px",
                                        paddingLeft: "5px",
                                      }}
                                    >
                                      (b) No claim to attach hereto for any loss
                                      arising from the repossession of property
                                      by any title holder or arising out of the
                                      contractual agreement to which any Insured
                                      protected under this Insurance may be
                                      party.
                                    </li>
                                    <li
                                      style={{
                                        marginBottom: "10px",
                                        paddingLeft: "5px",
                                      }}
                                    >
                                      (c) No claim to attach hereto for delay,
                                      deterioration and/or loss of market.
                                    </li>
                                    <li
                                      style={{
                                        marginBottom: "10px",
                                        paddingLeft: "5px",
                                      }}
                                    >
                                      (D) no claim to attach hereto for any loss
                                      unless preliminary notification of any
                                      occurrence given rise to such loss shall
                                      have been advised in writing to
                                      underwriters as soon as practicable, and
                                      the insured undertake that at all times
                                      from the date of such preliminary
                                      notification they will do and concur in
                                      doing al l things reasonably practicable
                                      to avoid or diminish the loss and to
                                      recover the whole of the property insured
                                      by this insurance.
                                    </li>
                                  </ul>
                                </li>

                                <li
                                  style={{
                                    marginBottom: "10px",
                                    paddingLeft: "5px",
                                  }}
                                >
                                  <ul
                                    style={{
                                      listStyle: "none",
                                      marginTop: "10px",
                                    }}
                                  >
                                    <li
                                      style={{
                                        marginBottom: "10px",
                                        paddingLeft: "5px",
                                      }}
                                    >
                                      (a) Warranted that the insured comply with
                                      all aspects with the laws (local or
                                      otherwise) of any country within whose
                                      jurisdiction the property is likely to be
                                      in normal course of events.
                                    </li>
                                    <li
                                      style={{
                                        marginBottom: "10px",
                                        paddingLeft: "5px",
                                      }}
                                    >
                                      (b) Warranted all permits necessary for
                                      normal legal operation are obtained.
                                      <p style={{marginTop: "10px"}}>
                                        Should failure to comply with the above
                                        warranties prejudice this insurance to
                                        the extent of a loss, no liability shall
                                        attach hereunder.
                                      </p>
                                      <p style={{marginTop: "10px"}}>
                                        In the event of any claim hereunder, the
                                        Insured undertake to subrogate to
                                        insurers the right to procedure against
                                        any other parties for the recovery of,
                                        or in respect of, the said property.
                                      </p>
                                      <p style={{marginTop: "10px"}}>
                                        This Insurance does not cover any loss
                                        or damage which at the time of the
                                        happening of such loss or damage is
                                        insured by or would, but for the
                                        existence of this insurance, but insured
                                        by any other Contract or polices except
                                        in respect of any excess beyond the
                                        amount which would have been payable
                                        under such other contract or policies
                                        had this insurance not been effected.
                                      </p>
                                      <p style={{marginTop: "10px"}}>
                                        Insurers subscribing to this insurance
                                        hereby agree that inf a new Government
                                        is installed in any place and after
                                        becoming the recognised or de facto
                                        Government of the place proceeded to
                                        confiscate or expropriate property by
                                        Government action by decree or other
                                        legislation or otherwise they would
                                        settle a loss if it fell under the terms
                                        of the insurance.
                                      </p>
                                      <p style={{marginTop: "10px"}}>
                                        Insurers subscribing hereto acknowledge
                                        and accept that the Government might
                                        have been ‘installed’ by force or armed
                                        revolt.
                                      </p>
                                    </li>
                                  </ul>
                                </li>
                              </ul>
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
              </ul>

              <div>
                <h3 style={{marginBottom: "15px"}}>
                  COMPLAINTS HANDLING POLICY
                </h3>
                <p style={{marginBottom: "10px"}}>
                  For the purpose of this notice “We”/“Us”/”Our” refers to{" "}
                  <strong>Convex Insurance UK Limited</strong> and “You”/”Your”
                  refers to the Insured.
                </p>
                <p style={{marginBottom: "10px"}}>
                  Our aim is always to provide You with the best possible
                  service. If You feel that We have not provided that service or
                  made an error, then please advise Us in the first instance. We
                  will take Your complaint seriously and do Our best to
                  investigate and resolve it as quickly as possible. We have
                  established the following Complaints handling procedure to
                  ensure that this happens.
                </p>

                <h4 style={{marginTop: "15px", marginBottom: "10px"}}>
                  Step 1
                </h4>
                <ul style={{listStyle: "num"}}>
                  <li style={{marginBottom: "10px", paddingLeft: "5px"}}>
                    Tell Us about it. There are different ways You can do that,
                    You can contact Us by email, telephone, or letter.
                  </li>
                  <li style={{marginBottom: "10px", paddingLeft: "5px"}}>
                    In the first instance, contact the <strong>Broker</strong>{" "}
                    through whom this insurance was placed and whose contact
                    details are listed on the certificate. Let them know that
                    You are dissatisfied with the service You have received and
                    tell them why.
                  </li>
                  <li style={{marginBottom: "10px", paddingLeft: "5px"}}>
                    Communicate directly with the <strong>Coverholder</strong>,
                    who is authorized to deal with any service-related
                    complaints.
                  </li>
                  <li style={{marginBottom: "10px", paddingLeft: "5px"}}>
                    Where you are unable to resolve your concerns with the
                    Broker or Coverholder you can contact the{" "}
                    <strong>Department of Insurance (DOI)</strong> for your
                    state, who will assist you in the fair resolution of Your
                    complaint.
                  </li>
                  <li style={{marginBottom: "10px", paddingLeft: "5px"}}>
                    Contact Our complaints team:
                    <ul style={{listStyle: "none"}}>
                      <li
                        style={{
                          marginBottom: "5px",
                          paddingLeft: "10px",
                          marginTop: "10px",
                        }}
                      >
                        {" "}
                        <strong>Email :</strong>{" "}
                        <a
                          style={{textDecorationLine: "none", color: "inherit"}}
                          href="mailto:complaints@convexin.com"
                          target="blank"
                        >
                          complaints@convexin.com
                        </a>
                      </li>
                      <li style={{marginBottom: "5px", paddingLeft: "10px"}}>
                        {" "}
                        <strong>Tel :</strong> +44 (0)7919 603210
                      </li>

                      <li style={{marginBottom: "5px", paddingLeft: "10px"}}>
                        <strong> Address : </strong> Convex Insurance UK
                        Limited, 52 Lime Street, London EC3M 7AF, United Kingdom
                      </li>
                    </ul>
                  </li>
                </ul>

                <p style={{marginBottom: "10px"}}>
                  <strong>We</strong> will acknowledge Your complaint promptly
                  and let You know who will be handling Your complaint and
                  provide You with their contact details.
                </p>

                <h4 style={{marginTop: "15px", marginBottom: "10px"}}>
                  Step 2
                </h4>
                <p style={{marginBottom: "10px"}}>
                  <strong>We</strong> aim to resolve Your complaint as soon as
                  possible. If it is complicated or <strong>We</strong> need to
                  investigate the circumstances further, then{" "}
                  <strong>We</strong> may not be able to resolve it straight
                  away and it may take longer depending on its complexity.{" "}
                  <strong>We</strong> aim to get You a final response within
                  eight (8) <strong>we</strong>eks of receiving Your complaint.
                  If <strong>We</strong> cannot do so, then <strong>We</strong>{" "}
                  will tell You why it is taking more time and let You know what{" "}
                  <strong>We</strong> are doing and how long <strong>We</strong>{" "}
                  expect it will take to resolve.
                </p>
                <p style={{marginBottom: "10px"}}>
                  Where You refer your complaint to the DOI <strong>we</strong>{" "}
                  will handle the complaint in accordance with the directions of
                  the DOI.
                </p>

                <h4 style={{marginTop: "15px", marginBottom: "10px"}}>
                  Step 3
                </h4>
                <p style={{marginBottom: "10px"}}>
                  If <strong>You</strong> are not happy with{" "}
                  <strong>Our</strong> response, or actions, and feel that the
                  matter has not been resolved to <strong>Your</strong>{" "}
                  satisfaction, then there are two options to take it further:
                </p>
                <ul style={{listStyle: "none"}}>
                  <li style={{marginBottom: "10px", paddingLeft: "5px"}}>
                    1. If <strong>You</strong> have not sent your complaint via
                    your state’s <strong>DOI</strong>, you can refer the
                    complaint to them. Please check your state’s DOI and how to
                    refer a complaint to them.
                  </li>
                  <li style={{marginBottom: "10px", paddingLeft: "5px"}}>
                    2. Alternatively, <strong>You</strong> may contact Lorraine
                    Mullins, the Chief Compliance Officer of Convex Insurance UK
                    Limited.
                    <ul style={{listStyle: "none", marginTop: "10px"}}>
                      <li style={{marginBottom: "5px", paddingLeft: "10px"}}>
                        <strong> Email: </strong>{" "}
                        <a
                          style={{textDecorationLine: "none", color: "inherit"}}
                          href="mailto:lorraine@convexin.com"
                          target="blank"
                        >
                          lorraine@convexin.com
                        </a>
                      </li>
                      <li style={{marginBottom: "5px", paddingLeft: "10px"}}>
                        <strong> Address : </strong>
                        <br /> Convex Insurance UK Limited,
                        <br /> 52 Lime Street,
                        <br /> London EC3M 7AF, <br /> United Kingdom
                      </li>
                    </ul>
                  </li>
                </ul>

                <h4 style={{marginTop: "15px", marginBottom: "10px"}}>
                  Our Commitment
                </h4>
                <p style={{marginBottom: "10px"}}>
                  All complaints are reported to, and overseen by, the Chief
                  Compliance Officer. If We get a complaint or have done
                  something wrong or failed to do something well, We will do our
                  best to put it right and to learn from it by{" "}
                  <strong>root cause analysis</strong> (this is where Convex
                  Insurance UK Limited will sample a selection of complaints and
                  what caused them then to address the causes).
                </p>
                <p style={{marginBottom: "10px"}}>
                  of the complaints as explained further). <strong>We</strong>{" "}
                  will make sure that <strong>We</strong> investigate and
                  establish what went wrong and why. <strong>We</strong>
                  will then work out what <strong>We</strong> need to do to
                  prevent that happening in the future and consider whether any
                  other customers could have been affected. Irrespective of
                  whether <strong>We</strong> have had complaints{" "}
                  <strong>We</strong> will report regularly on complaints and
                  root cause analysis and remediation in <strong>Our</strong>{" "}
                  management information to the executive management committees
                  and to the Board of Convex Insurance UK Limited.{" "}
                </p>
                <h4 style={{marginTop: "15px", marginBottom: "10px"}}>
                  FAIR PROCESSING NOTICE{" "}
                </h4>

                <p style={{marginBottom: "10px"}}>
                  This Privacy Notice describes how Convex Insurance UK Limited
                  (for the purpose of this notice <strong>“We”, “Us”</strong> or
                  "Convex Insurance UK Limited") collect and use the personal
                  information of insureds, claimants and other parties (for the
                  purpose of this notice <strong>“You”)</strong> when{" "}
                  <strong>We</strong> are providing <strong>Our</strong>{" "}
                  insurance and reinsurance services.
                </p>

                <h4 style={{marginTop: "15px", marginBottom: "10px"}}>
                  How We Will Use Your Data{" "}
                </h4>

                <p style={{marginBottom: "10px"}}>
                  The information provided to Convex Insurance UK Limited,
                  together with medical and any other information obtained from
                  You or from other parties about <strong>You</strong> in
                  connection with this <strong>Policy</strong>, will be used by
                  Convex Insurance UK Limited for the purposes of determining{" "}
                  <strong>Your</strong> application, the operation of insurance
                  (which includes the process of underwriting, administration,
                  claims management, analytics relevant to insurance,
                  rehabilitation and customer concerns handling) and fraud
                  prevention and detection. <strong>We</strong> may be required,
                  by law, to collect certain personal information about You, or
                  because of any contractual relationship <strong>We</strong>{" "}
                  have with <strong>You</strong>. Failure to provide this
                  information may prevent or delay the fulfilment of these
                  obligations.
                </p>
                <p style={{marginBottom: "10px"}}>
                  Information will be shared by Convex Insurance UK Limited for
                  these purposes with other group companies and third parties,
                  insurance intermediaries and service providers. Such parties
                  may become{" "}
                  <strong>Data Controllers (a “Data Controller”</strong>{" "}
                  determines the purposes for which and the means by which
                  personal data is processed), in respect of Your personal
                  information. Because <strong>We</strong> operate as part of a
                  global business, <strong>We</strong> may transfer{" "}
                  <strong>Your</strong> personal information outside the
                  European Economic Area for these purposes.
                </p>

                <h4 style={{marginTop: "15px", marginBottom: "10px"}}>
                  Your Rights Regarding Your Personal Information{" "}
                </h4>
                <p style={{marginBottom: "10px"}}>
                  You have certain rights regarding Your personal information,
                  under local law. These include the rights to request access,
                  rectification, erasure, restriction, objection, and receipt of
                  Your personal information in a usable electronic format and to
                  transmit it to a third party (right to portability).
                </p>
                <p style={{marginBottom: "10px"}}>
                  If You have questions or concerns regarding the way in which
                  Your personal information has been used, please contact the
                  Data Protection Officer, Lorraine Mullins, by email or letter
                  at:
                </p>

                <ul style={{listStyle: "none", marginTop: "10px"}}>
                  <li style={{marginBottom: "5px", paddingLeft: "10px"}}>
                    <a
                      style={{color: "inherit"}}
                      href="mailto:dataprotectionofficer@convexin.com"
                      target="blank"
                    >
                      dataprotectionofficer@convexin.com
                    </a>
                  </li>
                  <li style={{marginBottom: "5px", paddingLeft: "10px"}}>
                    <strong> Address : </strong>
                    <br /> Convex Insurance UK Limited, <br /> 52 Lime Street,{" "}
                    <br /> London EC3M 7AF, <br />
                    United Kingdom
                  </li>
                </ul>

                <p style={{marginBottom: "10px"}}>
                  We are committed to working with You to obtain a fair
                  resolution of any concern about privacy. If, however, you
                  believe that We have not been able to assist with your
                  concern, You have the right to make a complaint to the UK
                  Information Commissioner's Office (“ICO”).
                </p>
                <p style={{marginBottom: "10px"}}>
                  For more information about how We process your personal
                  information, please see Our full privacy notice at:
                  <a
                    style={{color: "inherit"}}
                    href="https://convexin.com/privacy-policy/"
                  >
                    {" "}
                    https://convexin.com/privacy-policy/
                  </a>{" "}
                  or for a written copy please contact Us at:
                </p>

                <ul style={{listStyle: "none", marginTop: "10px"}}>
                  <li style={{marginBottom: "5px", paddingLeft: "10px"}}>
                    <strong> Address : </strong>
                    <br /> Convex Insurance UK Limited, <br /> 52 Lime Street,{" "}
                    <br /> London EC3M 7AF, <br />
                    United Kingdom
                  </li>
                </ul>
              </div>

              <div className="policy-section">
                <h2 style={{marginBottom: "10px"}}>Section re TRIA</h2>

                <h4>
                  clause to be used if an Insured has purchased TRIA cover
                </h4>

                <p style={{marginBottom: "10px"}}>
                  U.S. TERRORISM RISK INSURANCE ACT OF 2002 AS AMENDED - NEW &
                  RENEWAL BUSINESS CLAUSE This clause is issued in accordance
                  with the terms and conditions of the "U.S. Terrorism Risk
                  Insurance Act of 2002" as amended, as summarized in the
                  disclosure notice.{" "}
                </p>

                <p style={{marginBottom: "10px"}}>
                  In consideration of an additional premium of{" "}
                  <strong>USD xxxx</strong> paid, it is hereby noted and agreed
                  with effect from inception that the Terrorism exclusion to
                  which this Insurance is subject, shall not apply to any
                  “insured loss” directly resulting from any “act of terrorism”
                  as defined in the{" "}
                  <strong>"U.S. Terrorism Risk Insurance Act of 2002"</strong>,
                  as amended (“TRIA”).
                </p>

                <p style={{marginBottom: "10px"}}>
                  The coverage afforded by this Endorsement is only in respect
                  of any “insured loss” of the type insured by this Insurance
                  directly resulting from an "act of terrorism" as defined in
                  TRIA. The coverage provided by this Endorsement shall expire
                  at 12:00 midnight December 31, 2027, the date on which the
                  TRIA Program is scheduled to terminate, or the expiry date of
                  the policy whichever occurs first, and shall not cover any
                  losses or events which arise after the earlier of these dates.
                  The Terrorism exclusion, to which this Insurance is subject,
                  applies in full force and effect to any other losses and any
                  act or events that are not included in said definition of "act
                  of terrorism".
                </p>

                <p style={{marginBottom: "10px"}}>
                  This Endorsement only affects the Terrorism exclusion to which
                  this Insurance is subject
                </p>

                <p style={{marginBottom: "10px"}}>
                  All other terms, conditions, insured coverage and exclusions
                  of this Insurance including applicable limits and deductibles
                  remain unchanged and apply in full force and effect to the
                  coverage provided by this Insurance.
                </p>

                <p style={{marginBottom: "10px"}}>
                  Furthermore, the Underwriter(s) will not be liable for any
                  amounts for which they are not responsible under the terms of
                  TRIA (including subsequent action of Congress pursuant to the
                  Act) due to the application of any clause which results in a
                  cap on the Underwriter’s liability for payment for terrorism
                  losses.
                </p>

                <p className="clause-code">LMA5389 — 09 January 2020</p>

                <hr className="divider" />
                <strong>
                  OR clause to be used if an Insured has not purchased TRIA
                  cover
                </strong>

                <h3 style={{marginBottom: "10px"}}>
                  U.S. TERRORISM RISK INSURANCE ACT OF 2002 AS AMENDED NOT
                  PURCHASED CLAUSE
                </h3>

                <p style={{marginBottom: "10px"}}>
                  This clause is issued in accordance with the terms and
                  conditions of the
                  <strong>
                    {" "}
                    "U.S. Terrorism Risk Insurance Act of 2002"{" "}
                  </strong>{" "}
                  as amended, as summarized in the disclosure notice.
                </p>

                <p style={{marginBottom: "10px"}}>
                  It is hereby noted that the Underwriters have made available
                  coverage for “insured losses” directly resulting from an "act
                  of terrorism" as defined in TRIA and the Insured has declined
                  or not confirmed to purchase this coverage.
                </p>

                <p style={{marginBottom: "10px"}}>
                  This Insurance therefore affords no coverage for losses
                  directly resulting from any "act of terrorism" as defined in
                  TRIA except to the extent, if any, otherwise provided by this
                  policy. All other terms, conditions, insured coverage and
                  exclusions of this Insurance including applicable limits and
                  deductibles remain unchanged and apply in full force and
                  effect to the coverage provided by this Insurance.
                </p>

                <p className="clause-code">LMA5390 — 09 January 2020</p>
                <hr className="divider" />
                <h3 style={{marginTop: "10px"}}> INFORMATION </h3>
                <p style={{marginBottom: "10px"}}>
                  2025 proposal form seen and noted by the Leading
                  Underwriter(s).{" "}
                </p>

                <hr className="divider" />

                <h2 style={{marginBottom: "10px", marginTop: "10px"}}>
                  SECURITY DETAILS
                </h2>

                <h4 style={{marginBottom: "5px"}}>(Re)Insurer’s Liability</h4>
                <h4 style={{marginBottom: "5px"}}>
                  (Re)Insurer’s Liability Clause
                </h4>
                <p style={{marginBottom: "10px"}}>
                  (Re)Insurer’s Liability Several Not Joint
                </p>

                <p style={{marginBottom: "10px"}}>
                  The liability of an Insurer under this contract is several and
                  not joint with other Insurers party to this contract. An
                  Insurer is liable only for the proportion of liability it has
                  underwritten. An Insurer is not jointly liable for the
                  proportion of liability underwritten by any other Insurer. Nor
                  is an Insurer otherwise responsible for any liability of any
                  other Insurer that may underwrite this contract.
                </p>

                <p style={{marginBottom: "10px"}}>
                  The proportion of liability under this contract underwritten
                  by an Insurer (or, in the case of a Lloyd’s syndicate, the
                  total of the proportions underwritten by all the members of
                  the syndicate taken together) is shown next to its stamp. This
                  is subject always to the provision concerning “signing” below.
                </p>

                <p style={{marginBottom: "10px"}}>
                  In the case of a Lloyd’s syndicate, each member of the
                  syndicate (rather than the syndicate itself) is an Insurer.
                  Each member has underwritten a proportion of the total shown
                  for the syndicate (that total itself being the total of the
                  proportions underwritten by all the members of the syndicate
                  taken together). The liability of each member of the syndicate
                  is several and not joint with other members. A member is
                  liable only for that member’s proportion. A member is not
                  jointly liable for any other member’s proportion. Nor is any
                  member otherwise responsible for any liability of any other
                  Insurer that may underwrite this contract.
                </p>

                <p style={{marginBottom: "10px"}}>
                  The business address of each member is{" "}
                  <strong>Lloyd’s, One Lime Street, London EC3M 7HA</strong>.
                  The identity of each member of a Lloyd’s syndicate and their
                  respective proportion may be obtained by writing to Market
                  Services, Lloyd’s, at the above address.
                </p>

                <h3>Proportion of Liability</h3>

                <p style={{marginBottom: "10px"}}>
                  Unless there is “signing” (see below), the proportion of
                  liability under this contract underwritten by each Insurer
                  (or, in the case of a Lloyd’s syndicate, the total of the
                  proportions underwritten by all the members of the syndicate
                  taken together) is shown next to its stamp and is referred to
                  as its “written line”.
                </p>

                <p style={{marginBottom: "10px"}}>
                  Where this contract permits, written lines, or certain written
                  lines, may be adjusted (“signed”). In that case a schedule is
                  to be appended to this contract to show the definitive
                  proportion of liability under this contract underwritten by
                  each Insurer (or, in the case of a Lloyd’s syndicate, the
                  total of the proportions underwritten by all the members of
                  the syndicate taken together). A definitive proportion (or, in
                  the case of a Lloyd’s syndicate, the total of the proportions
                  underwritten by all the members of a Lloyd’s syndicate taken
                  together) is referred to as a “signed line”. The signed lines
                  shown in the schedule will prevail over the written lines
                  unless a proven error in calculation has occurred.
                </p>

                <p style={{marginBottom: "10px"}}>
                  Although reference is made at various points in this clause to
                  “this contract” in the singular, where the circumstances so
                  require this should be read as a reference to contracts in the
                  plural.
                </p>

                <p className="clause-code">LMA3333 — 21 June 2007</p>

                <h2 style={{marginBottom: "10px"}}>Mode Of Execution Clause</h2>

                <p style={{marginBottom: "10px"}}>
                  This contract and any changes to it may be executed by:
                </p>

                <ul style={{listStyle: "none"}}>
                  <li style={{marginBottom: "10px"}}>
                    <strong>a.</strong> Electronic signature technology
                    employing computer software and a digital signature or
                    digitiser pen pad to capture a person’s handwritten
                    signature in such a manner that the signature is unique to
                    the person signing, is under the sole control of the person
                    signing, is capable of verification to authenticate the
                    signature and is linked to the document signed in such a
                    manner that if the data is changed, such signature is
                    invalidated;
                  </li>
                  <li style={{marginBottom: "10px"}}>
                    <strong>b.</strong> A unique authorisation provided via a
                    secure electronic trading platform.
                  </li>
                  <li style={{marginBottom: "10px"}}>
                    <strong>c.</strong> A timed and dated authorisation provided
                    via an electronic message/system.
                  </li>
                  <li style={{marginBottom: "10px"}}>
                    <strong>d.</strong> An exchange of facsimile/scanned copies
                    showing the original written ink signature of paper
                    documents.
                  </li>
                  <li style={{marginBottom: "10px"}}>
                    <strong>e.</strong> An original written ink signature of
                    paper documents (or a true representation of a signature,
                    such as a rubber stamp).
                  </li>
                </ul>

                <p>
                  The use of any one or a combination of these methods of
                  execution shall constitute a legally binding and valid signing
                  of this contract. This contract may be executed in one or more
                  of the above counterparts, each of which, when duly executed,
                  shall be deemed an original.
                </p>

                <h3 style={{marginTop: "10px"}}>Order Hereon</h3>
                <p style={{marginBottom: "10px"}}>
                  100% of 100% of limits and amounts herein.
                </p>

                <h3 style={{marginTop: "10px"}}>Written Lines</h3>

                <h4 style={{marginTop: "10px"}}>Basis of Written Lines</h4>
                <p>
                  In a co-insurance contract, following Insurers may, but are
                  not obliged to, follow the premium charged by the lead
                  Insurer. Insurers may not seek to guarantee for themselves
                  terms as favourable as those which others subsequently achieve
                  during the contract.
                </p>

                <h4 style={{marginTop: "10px"}}>Basis of Signed Lines</h4>
                <p>Percentage of Order</p>

                <h3 style={{marginTop: "10px"}}>Signing Provisions</h3>
                <p>
                  In the event that the written lines hereon exceed 100% of the
                  order, any lines written “to stand” will be allocated in full
                  and all other lines will be signed down in equal proportions
                  so that the aggregated signed lines are equal to 100% of the
                  order without further agreement of any of the insurers.
                </p>

                <p>However:</p>

                <ul style={{listStyle: "none", marginTop: "10px"}}>
                  <li>
                    <strong>(a)</strong> In the event that the placement of the
                    order is not completed by the commencement date of the
                    period of Insurance then all lines written by that date will
                    be signed in full.
                  </li>
                  <li style={{marginTop: "15px"}}>
                    <strong>(b)</strong> the disproportionate signing of
                    Insurers’ lines can be affected without further specific
                    agreement of Insurers, providing that any such variation is
                    made prior to the commencement date of the period of
                    Insurance, and that lines written ‘to stand’ may not be
                    varied without the documented agreement of those Insurers;
                  </li>
                  <li style={{marginTop: "15px"}}>
                    <strong>(c)</strong> the signed lines resulting from the
                    application of the above provisions can be varied, before or
                    after the commencement date of the period of Insurance, by
                    the documented agreement of the Insured and all Insurers
                    whose lines are to be varied. The variation to the contracts
                    will take effect only when all such Insurers have agreed,
                    with the resulting variation in signed lines commencing from
                    the date set out in the agreement
                  </li>
                </ul>
              </div>
            </Box>
          </CardContent>
        </Card>
      </Container>
    </>
  );
}

export default JewellersBlockPolicy;
